webpackJsonp([30],{

/***/ "+Knr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav"},[_c('div',{staticClass:"nav-head"},[_c('div',{staticClass:"app"},[_c('img',{staticClass:"appAvatar",attrs:{"src":this.$store.state.user.appAvatar,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"nav-btn",on:{"click":_vm.hiddenNavMethods}},[(!_vm.$store.state.hiddenNav)?_c('i',{staticClass:"el-icon-d-arrow-left"}):_c('i',{staticClass:"el-icon-d-arrow-right"})])]),_vm._v(" "),_c('div',{staticClass:"history-con"},[_c('history')],1),_vm._v(" "),_c('div',{staticClass:"userCon"},[_c('el-dropdown',{on:{"command":_vm.clickDropdown}},[_c('span',{staticClass:"el-dropdown-link"},[_c('div',{staticClass:"user"},[_c('img',{staticClass:"avatar",attrs:{"src":this.$store.state.user.avatar,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v(_vm._s(this.$store.state.user.name))])])]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{attrs:{"command":"openPersonal"}},[_vm._v("个人中心")]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":"logout"}},[_vm._v("退出登录")])],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"list",class:{'hidden-nav-list':_vm.$store.state.hiddenNav}},[_c('vue-scroll',{attrs:{"ops":_vm.ops2}},_vm._l((this.$store.state.navigationList),function(item,index){return (_vm.show(item.role)  && (item.nav != 'chat' || _vm.$store.state.user.chatPrivate))?_c('div',{key:index + 'super',staticClass:"con"},[_c('div',{staticClass:"item super",class:{actSuper : _vm.$route.meta.nav == item.nav},on:{"click":function($event){_vm.clickSuper(item,index)}}},[_c('i',{staticClass:"icon",class:item.icon}),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"8px"}},[_vm._v(_vm._s(item.text))]),_vm._v(" "),(item.child && item.child.length > 0)?_c('div',{staticClass:"unfold"},[(item.open)?_c('i',{staticClass:"el-icon-arrow-up"}):_c('i',{staticClass:"el-icon-arrow-down"})]):_vm._e()]),_vm._v(" "),_vm._l((item.child),function(childItem,childIndex){return (item.open && _vm.show(childItem.role))?_c('div',{key:childIndex + 'child',staticClass:"item child",class:{actChild : _vm.$route.meta.navChild == childItem.nav},on:{"click":function($event){_vm.clickChild(childItem,childIndex)}}},[_c('span',[_vm._v(_vm._s(childItem.text))])]):_vm._e()})],2):_vm._e()}))],1),_vm._v(" "),_c('el-dialog',{staticClass:"personal-dialog",attrs:{"title":"个人中心","visible":_vm.showPersonal,"before-close":_vm.closePersonal,"close-on-click-modal":false},on:{"update:visible":function($event){_vm.showPersonal=$event}}},[_c('vue-scroll',{attrs:{"ops":_vm.ops2}},[_c('div',{staticClass:"personal-dialog-con"},[_c('div',{staticClass:"personal-dialog-item"},[_c('img',{staticClass:"img",attrs:{"src":_vm.info.avatar,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"personal-dialog-item-name-con"},[_c('div',{staticClass:"personal-dialog-item-name"},[_vm._v(_vm._s(_vm.info.name))]),_vm._v(" "),_c('div',{staticClass:"personal-dialog-item-name",staticStyle:{"margin-top":"8px"}},[_vm._v(_vm._s(_vm.info.account))])])]),_vm._v(" "),_c('div',{staticClass:"personal-dialog-item",staticStyle:{"padding-top":"2px"}},[_c('div',{staticClass:"personal-dialog-item-left",staticStyle:{"height":"22px","line-height":"22px","margin-top":"8px"}},[_c('span',[_vm._v("客服组：")])]),_vm._v(" "),_vm._l((_vm.info.userGroup),function(item,index){return _c('div',{key:index,staticStyle:{"margin-top":"8px","color":"#fff","float":"left","background":"#409EFF","width":"70px","text-align":"center","height":"22px","line-height":"22px","margin-left":"10px"}},[_c('span',[_vm._v(_vm._s(item.name))])])})],2),_vm._v(" "),_c('div',{staticClass:"personal-dialog-item no-border"},[_c('div',{staticClass:"personal-dialog-item-left"},[_c('span',[_vm._v("角色：")])]),_vm._v(" "),_c('div',{staticClass:"personal-dialog-item-right"},[(_vm.info.myRole == 'admin')?_c('span',[_vm._v("超级管理员")]):_vm._e(),_vm._v(" "),(_vm.info.myRole == 'manager')?_c('span',[_vm._v("在线管理员")]):_vm._e(),_vm._v(" "),(_vm.info.myRole == 'service')?_c('span',[_vm._v("在线客服")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"personal-dialog-set-item",staticStyle:{"margin-top":"8px"}},[_c('div',{staticClass:"personal-dialog-set-title"},[_c('span',[_vm._v("个人配置")])]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"8px","overflow":"hidden"}},[_c('span',{staticStyle:{"float":"left"}},[_vm._v("通过公众号接受客服消息推送提醒：")]),_vm._v(" "),_c('div',{staticStyle:{"float":"right"}},[(_vm.info.receiveNotice)?_c('span',{staticStyle:{"vertical-align":"middle"}},[_vm._v("已开启")]):_c('span',{staticStyle:{"vertical-align":"middle"}},[_vm._v("已关闭")]),_vm._v(" "),_c('el-switch',{staticStyle:{"vertical-align":"middle","margin-left":"5px"},attrs:{"disabled":!_vm.info.appNoticeOpen,"active-color":"#13ce66","inactive-color":"#ff4949"},on:{"change":_vm.setCenter},model:{value:(_vm.info.receiveNotice),callback:function ($$v) {_vm.$set(_vm.info, "receiveNotice", $$v)},expression:"info.receiveNotice"}})],1)]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"8px","color":"#999"}},[_vm._v("开启消息推送服务后，您将通过服务号接收到相关的客服消息提醒")]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"8px","overflow":"hidden"}},[_c('span',{staticStyle:{"float":"left"}},[_vm._v("桌面新消息提醒：")]),_vm._v(" "),_c('div',{staticStyle:{"float":"right"}},[(_vm.info.receiveWebsocketNotify)?_c('span',{staticStyle:{"vertical-align":"middle"}},[_vm._v("已开启")]):_c('span',{staticStyle:{"vertical-align":"middle"}},[_vm._v("已关闭")]),_vm._v(" "),_c('el-switch',{staticStyle:{"vertical-align":"middle","margin-left":"5px"},attrs:{"active-color":"#13ce66","inactive-color":"#ff4949"},on:{"change":_vm.setWs},model:{value:(_vm.info.receiveWebsocketNotify),callback:function ($$v) {_vm.$set(_vm.info, "receiveWebsocketNotify", $$v)},expression:"info.receiveWebsocketNotify"}})],1)]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"8px","color":"#999"}},[_vm._v("开启新消息提醒后，新消息以桌面通知的方式进行提醒")])]),_vm._v(" "),_c('div',{staticClass:"personal-dialog-item",staticStyle:{"margin-top":"8px"}},[_c('div',{staticClass:"personal-dialog-item-left"},[_c('span',[_vm._v("姓名：")])]),_vm._v(" "),_c('div',{staticClass:"personal-dialog-item-right"},[_c('span',[_vm._v(_vm._s(_vm.info.userName))])])]),_vm._v(" "),_c('div',{staticClass:"personal-dialog-item no-border"},[_c('div',{staticClass:"personal-dialog-item-left"},[_c('span',[_vm._v("手机号：")])]),_vm._v(" "),_c('div',{staticClass:"personal-dialog-item-right"},[_c('span',[_vm._v(_vm._s(_vm.info.mobile))])])]),_vm._v(" "),_c('div',{staticStyle:{"height":"100px"}})])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+cgv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/GeR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var workload = function workload() {
    return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, "vr8i"));
};
var consultClassifyReport = function consultClassifyReport() {
    return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, "eAw4"));
};
var trendCount = function trendCount() {
    return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, "P5nT"));
};
var workQuality = function workQuality() {
    return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, "yFl/"));
};
var workQualityDetail = function workQualityDetail() {
    return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, "P2/X"));
};

/* harmony default export */ __webpack_exports__["a"] = ([{
    path: "/workReport/workload",
    name: "workload",
    components: {
        default: workload
    },
    meta: {
        nav: "workReport",
        navChild: "workload",
        navName: "工作量统计",
        keepAlive: true
    }
}, {
    path: "/workReport/consultClassifyReport",
    name: "consultClassifyReport",
    components: {
        default: consultClassifyReport
    },
    meta: {
        nav: "workReport",
        navChild: "consultClassifyReport",
        navName: "咨询分类统计",
        keepAlive: true
    }
}, {
    path: "/workReport/trendCount",
    name: "trendCount",
    components: {
        default: trendCount
    },
    meta: {
        nav: "workReport",
        navChild: "trendCount",
        navName: "分时统计",
        keepAlive: true
    }
}, {
    path: "/workReport/workQuality",
    name: "workQuality",
    components: {
        default: workQuality
    },
    meta: {
        nav: "workReport",
        navChild: "workQuality",
        navName: "工作质量概览",
        keepAlive: true
    }
}, {
    path: "/workReport/workQualityDetail",
    name: "workQualityDetail",
    components: {
        default: workQualityDetail
    },
    meta: {
        nav: "workReport",
        navChild: "workQualityDetail",
        navName: "工作质量详情",
        keepAlive: true
    }
}]);

/***/ }),

/***/ "/nV0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_js__ = __webpack_require__("rH90");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_historyTag___ = __webpack_require__("VIVP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_service___ = __webpack_require__("nKCs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_setting___ = __webpack_require__("7ell");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_workReport___ = __webpack_require__("/GeR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_chat___ = __webpack_require__("O37J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_system___ = __webpack_require__("lRg7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_workOrder___ = __webpack_require__("BLYk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_window___ = __webpack_require__("S0bA");















__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var RouterModel = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
    mode: 'hash',
    base: '/',
    routes: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_3__router_js__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_5__views_service___["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_6__views_setting___["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_4__views_historyTag___["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_7__views_workReport___["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_8__views_chat___["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_9__views_system___["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_10__views_workOrder___["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_11__views_window___["a" /* default */]))
});

RouterModel.beforeEach(function (to, from, next) {
    next();
});

RouterModel.afterEach(function (to, from) {});

/* harmony default export */ __webpack_exports__["a"] = (RouterModel);

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("j1ja");
module.exports = __webpack_require__("NHnr");


/***/ }),

/***/ "0gU3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/avatar.1c6417d.png";

/***/ }),

/***/ "3U+z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export yuan */
/* unused harmony export imgQuality */
/* unused harmony export emoji */
/* unused harmony export formatterDate */
/* unused harmony export active */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

var yuan = function yuan(value) {
	return !isNaN(value) ? '¥' + (value / 100).toFixed(2) : value;
};

var imgQuality = function imgQuality(value, width, height, q) {
	return value + "?imageView2/0/w/" + width + "/h/" + height + "/q/" + q;
};
var emoji = function emoji(value, format) {
	if (!value) {
		return '';
	}

	value = encodeHtml(value);
	value = TransferString(value);

	var qqfaceMap = { "[微笑]": "0", "[撇嘴]": "1", "[色]": "2", "[发呆]": "3", "[得意]": "4", "[流泪]": "5", "[害羞]": "6", "[闭嘴]": "7", "[睡]": "8", "[大哭]": "9", "[尴尬]": "10", "[发怒]": "11", "[调皮]": "12", "[呲牙]": "13", "[惊讶]": "14", "[难过]": "15", "[酷]": "16", "[冷汗]": "17", "[抓狂]": "18", "[吐]": "19", "[偷笑]": "20", "[可爱]": "21", "[白眼]": "22", "[傲慢]": "23", "[饥饿]": "24", "[困]": "25", "[惊恐]": "26", "[流汗]": "27", "[憨笑]": "28", "[大兵]": "29", "[努力]": "30", "[咒骂]": "31", "[疑问]": "32", "[嘘]": "33", "[晕]": "34", "[折磨]": "35", "[衰]": "36", "[骷髅]": "37", "[敲打]": "38", "[再见]": "39", "[擦汗]": "40", "[抠鼻]": "41", "[鼓掌]": "42", "[溴大了]": "43", "[坏笑]": "44", "[左哼哼]": "45", "[右哼哼]": "46", "[哈欠]": "47", "[鄙视]": "48", "[委屈]": "49", "[快哭了]": "50", "[阴险]": "51", "[亲亲]": "52", "[吓]": "53", "[可怜]": "54", "[菜刀]": "55", "[西瓜]": "56", "[啤酒]": "57", "[篮球]": "58", "[乒乓]": "59", "[咖啡]": "60", "[饭]": "61", "[猪头]": "62", "[玫瑰]": "63", "[凋谢]": "64", "[示爱]": "65", "[爱心]": "66", "[心碎]": "67", "[蛋糕]": "68", "[闪电]": "69", "[炸弹]": "70", "[刀]": "71", "[足球]": "72", "[瓢虫]": "73", "[便便]": "74", "[月亮]": "75", "[太阳]": "76", "[礼物]": "77", "[拥抱]": "78", "[强]": "79", "[弱]": "80", "[握手]": "81", "[胜利]": "82", "[抱拳]": "83", "[勾引]": "84", "[拳头]": "85", "[差劲]": "86", "[爱你]": "87", "[No]": "88", "[Ok]": "89", "[爱情]": "90", "[飞吻]": "91", "[跳舞]": "92", "[发抖]": "93", "[怄火]": "94", "[转圈]": "95", "[磕头]": "96", "[回头]": "97", "[跳绳]": "98", "[挥手]": "99", "[激动]": "100", "[街舞]": "101", "[献吻]": "102", "[左太极]": "103", "[右太极]": "104", "\uE415": "105", "\uE056": "106", "\uE057": "107", "\uE414": "108", "\uE405": "109", "\uE106": "110", "\uE418": "111", "\uE417": "112", "\uE40D": "113", "\uE40A": "114", "\uE404": "115", "\uE105": "116", "\uE409": "117", "\uE40E": "118", "\uE402": "119", "\uE108": "120", "\uE403": "121", "\uE058": "122", "\uE407": "123", "\uE401": "124", "\uE40F": "125", "\uE40B": "126", "\uE406": "127", "\uE413": "128", "\uE411": "129", "\uE412": "130", "\uE410": "131", "\uE107": "132", "\uE059": "133", "\uE416": "134", "\uE408": "135", "\uE40C": "136", "\uE11A": "137", "\uE10C": "138", "\uE32C": "139", "\uE32A": "140", "\uE32D": "141", "\uE328": "142", "\uE32B": "143", "\uE022": "144", "\uE023": "145", "\uE327": "146", "\uE329": "147", "\uE32E": "148", "\uE335": "149", "\uE334": "150", "\uE337": "151", "\uE336": "152", "\uE13C": "153", "\uE330": "154", "\uE331": "155", "\uE326": "156", "\uE03E": "157", "\uE11D": "158", "\uE05A": "159", "\uE00E": "160", "\uE421": "161", "\uE420": "162", "\uE00D": "163", "\uE010": "164", "\uE011": "165", "\uE41E": "166", "\uE012": "167", "\uE422": "168", "\uE22E": "169", "\uE22F": "170", "\uE231": "171", "\uE230": "172", "\uE427": "173", "\uE41D": "174", "\uE00F": "175", "\uE41F": "176", "\uE14C": "177", "\uE201": "178", "\uE115": "179", "\uE428": "180", "\uE51F": "181", "\uE429": "182", "\uE424": "183", "\uE423": "184", "\uE253": "185", "\uE426": "186", "\uE111": "187", "\uE425": "188", "\uE31E": "189", "\uE31F": "190", "\uE31D": "191", "\uE001": "192", "\uE002": "193", "\uE005": "194", "\uE004": "195", "\uE51A": "196", "\uE519": "197", "\uE518": "198", "\uE515": "199", "\uE516": "200", "\uE517": "201", "\uE51B": "202", "\uE152": "203", "\uE04E": "204", "\uE51C": "205", "\uE51E": "206", "\uE11C": "207", "\uE536": "208", "\uE003": "209", "\uE41C": "210", "\uE41B": "211", "\uE419": "212", "\uE41A": "213", "\uE436": "214", "\uE437": "215", "\uE438": "216", "\uE43A": "217", "\uE439": "218", "\uE43B": "219", "\uE117": "220", "\uE440": "221", "\uE442": "222", "\uE446": "223", "\uE445": "224", "\uE11B": "225", "\uE448": "226", "\uE033": "227", "\uE112": "228", "\uE325": "229", "\uE312": "230", "\uE310": "231", "\uE126": "232", "\uE127": "233", "\uE008": "234", "\uE03D": "235", "\uE00C": "236", "\uE12A": "237", "\uE00A": "238", "\uE00B": "239", "\uE009": "240", "\uE316": "241", "\uE129": "242", "\uE141": "243", "\uE142": "244", "\uE317": "245", "\uE128": "246", "\uE14B": "247", "\uE211": "248", "\uE114": "249", "\uE145": "250", "\uE144": "251", "\uE03F": "252", "\uE313": "253", "\uE116": "254", "\uE10F": "255", "\uE104": "256", "\uE103": "257", "\uE101": "258", "\uE102": "259", "\uE13F": "260", "\uE140": "261", "\uE11F": "262", "\uE12F": "263", "\uE031": "264", "\uE30E": "265", "\uE311": "266", "\uE113": "267", "\uE30F": "268", "\uE13B": "269", "\uE42B": "270", "\uE42A": "271", "\uE018": "272", "\uE016": "273", "\uE015": "274", "\uE014": "275", "\uE42C": "276", "\uE42D": "277", "\uE017": "278", "\uE013": "279", "\uE20E": "280", "\uE20C": "281", "\uE20F": "282", "\uE20D": "283", "\uE131": "284", "\uE12B": "285", "\uE130": "286", "\uE12D": "287", "\uE324": "288", "\uE301": "289", "\uE148": "290", "\uE502": "291", "\uE03C": "292", "\uE30A": "293", "\uE042": "294", "\uE040": "295", "\uE041": "296", "\uE12C": "297", "\uE007": "298", "\uE31A": "299", "\uE13E": "300", "\uE31B": "301", "\uE006": "302", "\uE302": "303", "\uE319": "304", "\uE321": "305", "\uE322": "306", "\uE314": "307", "\uE503": "308", "\uE10E": "309", "\uE318": "310", "\uE43C": "311", "\uE11E": "312", "\uE323": "313", "\uE31C": "314", "\uE034": "315", "\uE035": "316", "\uE045": "317", "\uE338": "318", "\uE047": "319", "\uE30C": "320", "\uE044": "321", "\uE30B": "322", "\uE043": "323", "\uE120": "324", "\uE33B": "325", "\uE33F": "326", "\uE341": "327", "\uE34C": "328", "\uE344": "329", "\uE342": "330", "\uE33D": "331", "\uE33E": "332", "\uE340": "333", "\uE34D": "334", "\uE339": "335", "\uE147": "336", "\uE343": "337", "\uE33C": "338", "\uE33A": "339", "\uE43F": "340", "\uE34B": "341", "\uE046": "342", "\uE345": "343", "\uE346": "344", "\uE348": "345", "\uE347": "346", "\uE34A": "347", "\uE349": "348", "\uE04A": "349", "\uE04B": "350", "\uE049": "351", "\uE048": "352", "\uE04C": "353", "\uE13D": "354", "\uE443": "355", "\uE43E": "356", "\uE04F": "357", "\uE052": "358", "\uE053": "359", "\uE524": "360", "\uE52C": "361", "\uE52A": "362", "\uE531": "363", "\uE050": "364", "\uE527": "365", "\uE051": "366", "\uE10B": "367", "\uE52B": "368", "\uE52F": "369", "\uE109": "370", "\uE528": "371", "\uE01A": "372", "\uE134": "373", "\uE530": "374", "\uE529": "375", "\uE526": "376", "\uE52D": "377", "\uE521": "378", "\uE523": "379", "\uE52E": "380", "\uE055": "381", "\uE525": "382", "\uE10A": "383", "\uE522": "384", "\uE019": "385", "\uE054": "386", "\uE520": "387", "\uE306": "388", "\uE030": "389", "\uE304": "390", "\uE110": "391", "\uE032": "392", "\uE305": "393", "\uE303": "394", "\uE118": "395", "\uE447": "396", "\uE119": "397", "\uE307": "398", "\uE308": "399", "\uE444": "400", "\uE441": "401", "\uE21C": "402", "\uE21D": "403", "\uE21E": "404", "\uE21F": "405", "\uE220": "406", "\uE221": "407", "\uE222": "408", "\uE223": "409", "\uE224": "410", "\uE225": "411", "\uE210": "412", "\uE232": "413", "\uE233": "414", "\uE235": "415", "\uE234": "416", "\uE236": "417", "\uE237": "418", "\uE238": "419", "\uE239": "420", "\uE23B": "421", "\uE23A": "422", "\uE23D": "423", "\uE23C": "424", "\uE24D": "425", "\uE212": "426", "\uE24C": "427", "\uE213": "428", "\uE214": "429", "\uE507": "430", "\uE203": "431", "\uE20B": "432", "\uE22A": "433", "\uE22B": "434", "\uE226": "435", "\uE227": "436", "\uE22C": "437", "\uE22D": "438", "\uE215": "439", "\uE216": "440", "\uE217": "441", "\uE218": "442", "\uE228": "443", "\uE151": "444", "\uE138": "445", "\uE139": "446", "\uE13A": "447", "\uE208": "448", "\uE14F": "449", "\uE20A": "450", "\uE434": "451", "\uE309": "452", "\uE315": "453", "\uE30D": "454", "\uE207": "455", "\uE229": "456", "\uE206": "457", "\uE205": "458", "\uE204": "459", "\uE12E": "460", "\uE250": "461", "\uE251": "462", "\uE14A": "463", "\uE149": "464", "\uE23F": "465", "\uE240": "466", "\uE241": "467", "\uE242": "468", "\uE243": "469", "\uE244": "470", "\uE245": "471", "\uE246": "472", "\uE247": "473", "\uE248": "474", "\uE249": "475", "\uE24A": "476", "\uE24B": "477", "\uE23E": "478", "\uE532": "479", "\uE533": "480", "\uE534": "481", "\uE535": "482", "\uE21A": "483", "\uE219": "484", "\uE21B": "485", "\uE02F": "486", "\uE024": "487", "\uE025": "488", "\uE026": "489", "\uE027": "490", "\uE028": "491", "\uE029": "492", "\uE02A": "493", "\uE02B": "494", "\uE02C": "495", "\uE02D": "496", "\uE02E": "497", "\uE332": "498", "\uE333": "499", "\uE24E": "500", "\uE24F": "501", "\uE537": "502", "\uE036": "503", "\uE157": "504", "\uE038": "505", "\uE153": "506", "\uE155": "507", "\uE14D": "508", "\uE156": "509", "\uE501": "510", "\uE158": "511", "\uE43D": "512", "\uE037": "513", "\uE504": "514", "\uE44A": "515", "\uE146": "516", "\uE154": "517", "\uE505": "518", "\uE506": "519", "\uE122": "520", "\uE508": "521", "\uE509": "522", "\uE03B": "523", "\uE04D": "524", "\uE449": "525", "\uE44B": "526", "\uE51D": "527", "\uE44C": "528", "\uE124": "529", "\uE121": "530", "\uE433": "531", "\uE202": "532", "\uE135": "533", "\uE01C": "534", "\uE01D": "535", "\uE10D": "536", "\uE136": "537", "\uE42E": "538", "\uE01B": "539", "\uE15A": "540", "\uE159": "541", "\uE432": "542", "\uE430": "543", "\uE431": "544", "\uE42F": "545", "\uE01E": "546", "\uE039": "547", "\uE435": "548", "\uE01F": "549", "\uE125": "550", "\uE03A": "551", "\uE14E": "552", "\uE252": "553", "\uE137": "554", "\uE209": "555", "\uE133": "556", "\uE150": "557", "\uE320": "558", "\uE123": "559", "\uE132": "560", "\uE143": "561", "\uE50B": "562", "\uE514": "563", "\uE513": "564", "\uE50C": "565", "\uE50D": "566", "\uE511": "567", "\uE50F": "568", "\uE512": "569", "\uE510": "570", "\uE50E": "571" };
	var str = /\[微笑\]|\[撇嘴\]|\[色\]|\[发呆\]|\[得意\]|\[流泪\]|\[害羞\]|\[闭嘴\]|\[睡\]|\[大哭\]|\[尴尬\]|\[发怒\]|\[调皮\]|\[呲牙\]|\[惊讶\]|\[难过\]|\[酷\]|\[冷汗\]|\[抓狂\]|\[吐\]|\[偷笑\]|\[可爱\]|\[白眼\]|\[傲慢\]|\[饥饿\]|\[困\]|\[惊恐\]|\[流汗\]|\[憨笑\]|\[大兵\]|\[努力\]|\[咒骂\]|\[疑问\]|\[嘘\]|\[晕\]|\[折磨\]|\[衰\]|\[骷髅\]|\[敲打\]|\[再见\]|\[擦汗\]|\[抠鼻\]|\[鼓掌\]|\[溴大了\]|\[坏笑\]|\[左哼哼\]|\[右哼哼\]|\[哈欠\]|\[鄙视\]|\[委屈\]|\[快哭了\]|\[阴险\]|\[亲亲\]|\[吓\]|\[可怜\]|\[菜刀\]|\[西瓜\]|\[啤酒\]|\[篮球\]|\[乒乓\]|\[咖啡\]|\[饭\]|\[猪头\]|\[玫瑰\]|\[凋谢\]|\[示爱\]|\[爱心\]|\[心碎\]|\[蛋糕\]|\[闪电\]|\[炸弹\]|\[刀\]|\[足球\]|\[瓢虫\]|\[便便\]|\[月亮\]|\[太阳\]|\[礼物\]|\[拥抱\]|\[强\]|\[弱\]|\[握手\]|\[胜利\]|\[抱拳\]|\[勾引\]|\[拳头\]|\[差劲\]|\[爱你\]|\[No\]|\[Ok\]|\[爱情\]|\[飞吻\]|\[跳舞\]|\[发抖\]|\[怄火\]|\[转圈\]|\[磕头\]|\[回头\]|\[跳绳\]|\[挥手\]|\[激动\]|\[街舞\]|\[献吻\]|\[左太极\]|\[右太极\]|\uE415|\uE056|\uE057|\uE414|\uE405|\uE106|\uE418|\uE417|\uE40D|\uE40A|\uE404|\uE105|\uE409|\uE40E|\uE402|\uE108|\uE403|\uE058|\uE407|\uE401|\uE40F|\uE40B|\uE406|\uE413|\uE411|\uE412|\uE410|\uE107|\uE059|\uE416|\uE408|\uE40C|\uE11A|\uE10C|\uE32C|\uE32A|\uE32D|\uE328|\uE32B|\uE022|\uE023|\uE327|\uE329|\uE32E|\uE335|\uE334|\uE337|\uE336|\uE13C|\uE330|\uE331|\uE326|\uE03E|\uE11D|\uE05A|\uE00E|\uE421|\uE420|\uE00D|\uE010|\uE011|\uE41E|\uE012|\uE422|\uE22E|\uE22F|\uE231|\uE230|\uE427|\uE41D|\uE00F|\uE41F|\uE14C|\uE201|\uE115|\uE428|\uE51F|\uE429|\uE424|\uE423|\uE253|\uE426|\uE111|\uE425|\uE31E|\uE31F|\uE31D|\uE001|\uE002|\uE005|\uE004|\uE51A|\uE519|\uE518|\uE515|\uE516|\uE517|\uE51B|\uE152|\uE04E|\uE51C|\uE51E|\uE11C|\uE536|\uE003|\uE41C|\uE41B|\uE419|\uE41A|\uE436|\uE437|\uE438|\uE43A|\uE439|\uE43B|\uE117|\uE440|\uE442|\uE446|\uE445|\uE11B|\uE448|\uE033|\uE112|\uE325|\uE312|\uE310|\uE126|\uE127|\uE008|\uE03D|\uE00C|\uE12A|\uE00A|\uE00B|\uE009|\uE316|\uE129|\uE141|\uE142|\uE317|\uE128|\uE14B|\uE211|\uE114|\uE145|\uE144|\uE03F|\uE313|\uE116|\uE10F|\uE104|\uE103|\uE101|\uE102|\uE13F|\uE140|\uE11F|\uE12F|\uE031|\uE30E|\uE311|\uE113|\uE30F|\uE13B|\uE42B|\uE42A|\uE018|\uE016|\uE015|\uE014|\uE42C|\uE42D|\uE017|\uE013|\uE20E|\uE20C|\uE20F|\uE20D|\uE131|\uE12B|\uE130|\uE12D|\uE324|\uE301|\uE148|\uE502|\uE03C|\uE30A|\uE042|\uE040|\uE041|\uE12C|\uE007|\uE31A|\uE13E|\uE31B|\uE006|\uE302|\uE319|\uE321|\uE322|\uE314|\uE503|\uE10E|\uE318|\uE43C|\uE11E|\uE323|\uE31C|\uE034|\uE035|\uE045|\uE338|\uE047|\uE30C|\uE044|\uE30B|\uE043|\uE120|\uE33B|\uE33F|\uE341|\uE34C|\uE344|\uE342|\uE33D|\uE33E|\uE340|\uE34D|\uE339|\uE147|\uE343|\uE33C|\uE33A|\uE43F|\uE34B|\uE046|\uE345|\uE346|\uE348|\uE347|\uE34A|\uE349|\uE04A|\uE04B|\uE049|\uE048|\uE04C|\uE13D|\uE443|\uE43E|\uE04F|\uE052|\uE053|\uE524|\uE52C|\uE52A|\uE531|\uE050|\uE527|\uE051|\uE10B|\uE52B|\uE52F|\uE109|\uE528|\uE01A|\uE134|\uE530|\uE529|\uE526|\uE52D|\uE521|\uE523|\uE52E|\uE055|\uE525|\uE10A|\uE522|\uE019|\uE054|\uE520|\uE306|\uE030|\uE304|\uE110|\uE032|\uE305|\uE303|\uE118|\uE447|\uE119|\uE307|\uE308|\uE444|\uE441|\uE21C|\uE21D|\uE21E|\uE21F|\uE220|\uE221|\uE222|\uE223|\uE224|\uE225|\uE210|\uE232|\uE233|\uE235|\uE234|\uE236|\uE237|\uE238|\uE239|\uE23B|\uE23A|\uE23D|\uE23C|\uE24D|\uE212|\uE24C|\uE213|\uE214|\uE507|\uE203|\uE20B|\uE22A|\uE22B|\uE226|\uE227|\uE22C|\uE22D|\uE215|\uE216|\uE217|\uE218|\uE228|\uE151|\uE138|\uE139|\uE13A|\uE208|\uE14F|\uE20A|\uE434|\uE309|\uE315|\uE30D|\uE207|\uE229|\uE206|\uE205|\uE204|\uE12E|\uE250|\uE251|\uE14A|\uE149|\uE23F|\uE240|\uE241|\uE242|\uE243|\uE244|\uE245|\uE246|\uE247|\uE248|\uE249|\uE24A|\uE24B|\uE23E|\uE532|\uE533|\uE534|\uE535|\uE21A|\uE219|\uE21B|\uE02F|\uE024|\uE025|\uE026|\uE027|\uE028|\uE029|\uE02A|\uE02B|\uE02C|\uE02D|\uE02E|\uE332|\uE333|\uE24E|\uE24F|\uE537|\uE036|\uE157|\uE038|\uE153|\uE155|\uE14D|\uE156|\uE501|\uE158|\uE43D|\uE037|\uE504|\uE44A|\uE146|\uE154|\uE505|\uE506|\uE122|\uE508|\uE509|\uE03B|\uE04D|\uE449|\uE44B|\uE51D|\uE44C|\uE124|\uE121|\uE433|\uE202|\uE135|\uE01C|\uE01D|\uE10D|\uE136|\uE42E|\uE01B|\uE15A|\uE159|\uE432|\uE430|\uE431|\uE42F|\uE01E|\uE039|\uE435|\uE01F|\uE125|\uE03A|\uE14E|\uE252|\uE137|\uE209|\uE133|\uE150|\uE320|\uE123|\uE132|\uE143|\uE50B|\uE514|\uE513|\uE50C|\uE50D|\uE511|\uE50F|\uE512|\uE510|\uE50E/g;
	return value.replace(str, function (r) {
		return '<i class="qqface qqface_' + qqfaceMap[r] + '"></i>';
	});
};

var REGX_HTML_ENCODE = /"|&|'|<|>|[\x00-\x20]|[\x7F-\xFF]|[\u0100-\u2700]/g;
function encodeHtml(s) {
	return typeof s != "string" ? s : s.replace(REGX_HTML_ENCODE, function ($0) {
		var c = $0.charCodeAt(0),
		    r = ["&#"];
		c = c == 0x20 ? 0xA0 : c;
		r.push(c);
		r.push(";");
		return r.join("");
	});
}

function TransferString(content) {
	var string = content;
	try {
		string = string.replace(/&#10;/g, "<br>");
		string = string.replace(/↵/g, "<br>");
		string = string.replace(/\r\n/g, "<br>");
		string = string.replace(/\r/g, "<br>");
		string = string.replace(/\n/g, "<br>");
	} catch (e) {
		console.log(e);
	}
	return string;
}

var formatterDate = function formatterDate(value, format) {
	if (!value) {
		return '';
	}
	// value = value.replace('T', ' ');
	switch (typeof value === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value)) {
		case "string":
			value = new Date(value.replace(/-/g, "/"));
			break;
		case "number":
			value = new Date(value);
			break;
	}
	if (!value instanceof Date) return '';
	var dict = {
		"yyyy": value.getFullYear(),
		"MM": ("" + (value.getMonth() + 101)).substr(1),
		"dd": ("" + (value.getDate() + 100)).substr(1),
		"HH": ("" + (value.getHours() + 100)).substr(1),
		"mm": ("" + (value.getMinutes() + 100)).substr(1),
		"ss": ("" + (value.getSeconds() + 100)).substr(1),
		"M": value.getMonth() + 1,
		"d": value.getDate(),
		"H": value.getHours(),
		"m": value.getMinutes(),
		"s": value.getSeconds()

	};
	for (var k in dict) {
		if (format.indexOf(k) >= 0) {
			format = format.replace(k, dict[k]);
		}
	}
	return format;
};

var active = function active(value, format) {
	if (!value) {
		return '';
	}
	if (format) {
		var reg = format;
		//转义 * . ? + $ ^ [ ] ( ) { } | \ /
		reg = reg.replace(/\\/g, "\\\\");

		reg = reg.replace(/\*/g, "\\*");
		reg = reg.replace(/\./g, "\\.");
		reg = reg.replace(/\?/g, "\\?");
		reg = reg.replace(/\+/g, "\\+");
		reg = reg.replace(/\$/g, "\\$");
		reg = reg.replace(/\^/g, "\\^");
		reg = reg.replace(/\[/g, "\\[");
		reg = reg.replace(/\]/g, "\\]");
		reg = reg.replace(/\(/g, "\\(");
		reg = reg.replace(/\)/g, "\\)");
		reg = reg.replace(/\{/g, "\\{");
		reg = reg.replace(/\}/g, "\\}");
		reg = reg.replace(/\|/g, "\\|");
		reg = reg.replace(/\//g, "\\/");
		var r = RegExp("" + reg + "", "g");
		return value.replace(r, function (r) {
			return "<b class=\"act\" style=\"color:#f44;font-weight:bold;\">" + format + "</b>";
		});
	}
	return value;
};

/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install(Vue) {
		Vue.filter('yuan', yuan);
		Vue.filter('formatterDate', formatterDate), Vue.filter('imgQuality', imgQuality), Vue.filter('emoji', emoji), Vue.filter('active', active);
	}
});

/***/ }),

/***/ "3f40":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3hlU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__("naDd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__("bggx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__("PLgo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__("GSMP");


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);




/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_4__getters__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_5__actions__["a" /* default */]
}));

/***/ }),

/***/ "4qOc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5KOv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5Qfy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_vuex_store__ = __webpack_require__("3hlU");


var setWechatShare = function setWechatShare() {
    var title = __WEBPACK_IMPORTED_MODULE_0__vue_vuex_store__["a" /* default */].state.wechatShare.title;
    var desc = __WEBPACK_IMPORTED_MODULE_0__vue_vuex_store__["a" /* default */].state.wechatShare.desc;
    var imgUrl = __WEBPACK_IMPORTED_MODULE_0__vue_vuex_store__["a" /* default */].state.wechatShare.imgUrl;
    var link = __WEBPACK_IMPORTED_MODULE_0__vue_vuex_store__["a" /* default */].state.wechatShare.link;
    /** 分享到朋友圈
     * 参数: 标题 图标 链接?
     */
    wx.onMenuShareTimeline({
        title: title, // 分享标题
        link: link, // 分享链接，该链接域名必须与当前企业的可信域名一致
        imgUrl: imgUrl, // 分享图标
        success: function success() {
            // 用户确认分享后执行的回调函数
            // alert("成功分享到朋友圈")
        },
        cancel: function cancel() {
            // 用户取消分享后执行的回调函数
            // alert("取消分享到朋友圈")
        }
    });
    /** 分享给朋友
     * 参数: 标题 描述 图标 链接?
     */
    wx.onMenuShareAppMessage({
        title: title, // 分享标题
        desc: desc, // 分享描述
        link: link, // 分享链接，该链接域名必须与当前企业的可信域名一致
        imgUrl: imgUrl, // 分享图标
        type: 'link', // 分享类型,music、video或link，不填默认为link
        dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
        success: function success() {
            // alert("成功分享给朋友")
            // 用户确认分享后执行的回调函数
        },
        cancel: function cancel() {
            // alert("取消分享给朋友")
            // 用户取消分享后执行的回调函数
        }
    });
};

var hideMenuItems = function hideMenuItems() {
    wx.hideMenuItems({
        menuList: ["menuItem:favorite", "menuItem:editTag", "menuItem:copyUrl", "menuItem:openWithQQBrowser", "menuItem:openWithSafari", "menuItem:share:email", "menuItem:readMode", "menuItem:share:brand"], // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
        fail: function fail() {
            // alert("减少按钮失败!")
        }
    });
};

var showMenuItems = function showMenuItems() {
    wx.showMenuItems({
        menuList: ["menuItem:share:appMessage", "menuItem:share:timeline", "menuItem:share:qq", "menuItem:share:QZone"], // 要显示的菜单项，所有menu项见附录3
        fail: function fail() {
            // alert("增加按钮失败!")
        }
    });
};

var chooseImage = function chooseImage() {
    wx.chooseImage({
        count: 1, // 默认9
        sizeType: ['original', 'compressed'], // 能够指定是原图还是压缩图，默认二者都有
        sourceType: ['album', 'camera'], // 能够指定来源是相冊还是相机，默认二者都有
        success: function success(res) {
            var localIds = res.localIds; // 返回选定照片的本地ID列表，localId能够作为img标签的src属性显示图片
        }
    });
};

/* harmony default export */ __webpack_exports__["a"] = ({
    install: function install(Vue) {
        Vue.prototype.$setWechatShare = setWechatShare, Vue.prototype.$hideMenuItems = hideMenuItems, Vue.prototype.$showMenuItems = showMenuItems, Vue.prototype.$chooseImage = chooseImage;
    }
});

/***/ }),

/***/ "5W1q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "78mb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"treeSelect"},[_c('input',{staticClass:"input-con",class:{act:_vm.showChild},attrs:{"placeholder":_vm.placeholder,"readonly":"readonly","type":"text"},domProps:{"value":_vm.value},on:{"focus":_vm.focus}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('v-tree-select-child',{on:{"close":_vm.close},model:{value:(_vm.showChild),callback:function ($$v) {_vm.showChild=$$v},expression:"showChild"}},[_vm._t("default")],2)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon-con"},[_c('i',{staticClass:"el-icon-arrow-down"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7ell":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var setting = function setting() {
    return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, "NjI1"));
};
var staff = function staff() {
    return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, "M1To"));
};
var groups = function groups() {
    return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, "nMzE"));
};
var taskGroup = function taskGroup() {
    return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, "KiUU"));
};
var app = function app() {
    return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, "1BDy"));
};
var onOff = function onOff() {
    return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, "a9QB"));
};
var time = function time() {
    return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, "Yeae"));
};
var messageTag = function messageTag() {
    return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, "v5l4"));
};
var consultClassify = function consultClassify() {
    return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, "GgSj"));
};

/* harmony default export */ __webpack_exports__["a"] = ([
// 设置
{
    path: "/setting",
    name: "setting",
    components: {
        default: setting
    },
    meta: {
        nav: "setting",
        navChild: "setting",

        keepAlive: true
    }
}, {
    path: "/setting/staff",
    name: "staff",
    components: {
        default: staff
    },
    meta: {
        nav: "setting",
        navChild: "staff",
        navName: "用户管理",
        keepAlive: true
    }
}, {
    path: "/setting/taskGroup",
    name: "taskGroup",
    components: {
        default: taskGroup
    },
    meta: {
        nav: "setting",
        navChild: "taskGroup",
        navName: "工单组管理",
        keepAlive: true
    }
}, {
    path: "/setting/groups",
    name: "groups",
    components: {
        default: groups
    },
    meta: {
        nav: "setting",
        navChild: "groups",
        navName: "客服组管理",
        keepAlive: true
    }
}, {
    path: "/setting/app",
    name: "app",
    components: {
        default: app
    },
    meta: {
        nav: "setting",
        navChild: "app",
        navName: "应用管理",
        keepAlive: true
    }
}, {
    path: "/setting/onOff",
    name: "onOff",
    components: {
        default: onOff
    },
    meta: {
        nav: "setting",
        navChild: "onOff",
        navName: "基础配置",
        keepAlive: true
    }
}, {
    path: "/setting/time",
    name: "time",
    components: {
        default: time
    },
    meta: {
        nav: "setting",
        navChild: "time",
        navName: "时间计划",
        keepAlive: true
    }
}, {
    path: "/setting/messageTag",
    name: "messageTag",
    components: {
        default: messageTag
    },
    meta: {
        nav: "setting",
        navChild: "messageTag",
        navName: "标签管理",
        keepAlive: true
    }
}, {
    path: "/setting/consultClassify",
    name: "consultClassify",
    components: {
        default: consultClassify
    },
    meta: {
        nav: "setting",
        navChild: "consultClassify",
        navName: "咨询分类管理",
        keepAlive: true
    }
}]);

/***/ }),

/***/ "8byh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_treeSelectChild_vue__ = __webpack_require__("vyKT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bd5ce0c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_treeSelectChild_vue__ = __webpack_require__("HWJ4");
function injectStyle (ssrContext) {
  __webpack_require__("F+y/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4bd5ce0c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_treeSelectChild_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bd5ce0c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_treeSelectChild_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AaPB":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAB3ElEQVRYR8WXv0scQRiGn1dSBiKmEwI2VmIjYmEaxUJCWiNoodgoaBfEFBZJYSGIWEWIlWkSSKxFxEJBFAsrUwVBIdoJyT8gn8xx6tzsejdHbuemnJ2d95nv54xo8lCT9flvADPrBz4DrcCMpN16DtUIgE/Ax7LoH+CtpLNYiEYAfAUmPMEVSQspAa6Bdk/wVFJvEgAzew0cBmJ/JbWlAvD9/6ApKdq10QvDE5lZN3AEPA+/pQLYBCbzTF04gJm9A3484edzSZ2FxUANcae7JckBRo26YiBC3InOSVqPUofHUmxmA15F8/+/lDTlJszMIjber7HmQJLLntJ4sICZLQJL1YIqEiCCsdQzNkKA2XJTyWxwH9UNBJiXtBoCjAHfEllgXNL3EGAY2EkEMCipFCt+DPQBJwkAbiU9ywtCVzx+JwDYleSsncmCl8BNAoAFSSt5AC3AbQKAfknHGYByofkHvAghGpiGmbtCRSk2swugo0CATJ8IAU6BngIB3kta8/cPAfaAoQIBKvxfUQfKMfATGCkI4ErSq8ze/oSZfQGmCwLYvO+q1VywDHyoAvAL6MpL1Yg592DZrmWB3KuWl4buGea65hsg+uoNjEpy7s2Mum5EEaese0nTAe4AWYLQIXLQfMAAAAAASUVORK5CYII="

/***/ }),

/***/ "B/Tc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BLYk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var allWorkOrder = function allWorkOrder() {
    return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "WotY"));
};
var myWorkOrder = function myWorkOrder() {
    return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "Li4N"));
};

/* harmony default export */ __webpack_exports__["a"] = ([{
    path: "/workOrder/allWorkOrder",
    name: "allWorkOrder",
    components: {
        default: allWorkOrder
    },
    meta: {
        nav: "workOrder",
        navChild: "allWorkOrder",
        navName: "全部工单",
        keepAlive: true
    }
}, {
    path: "/workOrder/myWorkOrder",
    name: "myWorkOrder",
    components: {
        default: myWorkOrder
    },
    meta: {
        nav: "workOrder",
        navChild: "myWorkOrder",
        navName: "我的工单",
        keepAlive: true
    }
}]);

/***/ }),

/***/ "CxY5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__table__ = __webpack_require__("KNpk");
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: "jsonType",
    props: {
        isPage: {
            type: Boolean,
            default: false
        },
        json: {
            type: String,
            required: true
        }
    },
    components: {
        "v-table": __WEBPACK_IMPORTED_MODULE_1__table__["a" /* default */]
    },
    computed: {
        showData: function showData() {
            var json = this.json;
            var obj = {};
            try {
                obj = JSON.parse(json);
            } catch (error) {
                console.log(error);
                obj = { error: true };
            }
            return obj;
        }
    },
    data: function data() {
        return {};
    },
    beforeDestroy: function beforeDestroy() {},
    created: function created() {},

    methods: {}
});

/***/ }),

/***/ "Dpyr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// 全局
/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {};
	},
	mounted: function mounted() {
		this.$nextTick(function () {
			// PC非微信浏览器  隐藏滚动条
			if (this.$IsPC()) {
				var el = this.$refs.scrollFixed;
				if (el) {
					el.style.marginRight = '-17px';
				}
			}
		});
	},
	created: function created() {}
});

/***/ }),

/***/ "F+y/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FkLF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {};
    },

    methods: {
        closeAll: function closeAll() {
            this.$clearHistory();
        },
        clickTag: function clickTag(e) {
            this.$router.push(e.path + '?refresh=no');
        },
        closeTag: function closeTag(e) {
            this.$store.state.historyList.splice(e, 1);
        }
    },
    mounted: function mounted() {}
});

/***/ }),

/***/ "FknX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"dragBox",staticClass:"drag-box"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GSMP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var actions = {
  // 登录凭证
  sessionId: function sessionId(_ref, status) {
    var commit = _ref.commit;

    commit('sessionId', status);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),

/***/ "HN0E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__ = __webpack_require__("k5WP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d94bc34_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__ = __webpack_require__("Whin");
function injectStyle (ssrContext) {
  __webpack_require__("zw0+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4d94bc34"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d94bc34_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HO0p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"RTF",staticClass:"RTF"},[_c('div',{staticClass:"edit_container"},[_c('dragImgUpload',{on:{"onChange":function($event){_vm.uploaderFileChange($event)}}},[_c('quill-editor',{ref:"quill",attrs:{"options":_vm.options},on:{"blur":function($event){_vm.onEditorBlur($event)},"focus":function($event){_vm.onEditorFocus($event)},"change":function($event){_vm.onEditorChange($event)}},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1),_vm._v(" "),_c('input',{ref:"quillImgInput",staticClass:"fileImg",staticStyle:{"position":"absolute","top":"3px","left":"3px","width":"26px","height":"26px","opacity":"0","cursor":"pointer","font-size":"0"},attrs:{"type":"file","name":"file","value":"","accept":"image/jpeg, image/png, image/jpg, image/gif","multiple":""},on:{"change":_vm.onRead}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HWJ4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('div',{staticClass:"treeSelectChildCon",on:{"click":_vm.close}},[_c('div',{staticClass:"treeSelectChild",style:(("top:" + (_vm.top + 42) + "px;left:" + _vm.left + "px;max-height:" + _vm.height + "px"))},[_c('div',[_vm._t("default")],2)])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "I3m/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main_vue__ = __webpack_require__("vob7");



var MessageConstructor = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_1__main_vue__["a" /* default */]);

var instance = void 0;

var previewImg = function previewImg(data) {

    // 必须传
    if (!data || !data.list && !data.list.length) {
        throw new Error('必须传list');
    }

    if (!instance) {
        instance = new MessageConstructor();
        instance.vm = instance.$mount();
    }

    document.body.appendChild(instance.vm.$el);

    // 添加数组
    if (data) {
        instance.vm.imgList = data.list ? data.list : [];
        instance.vm.index = data.index ? data.index : 0;
        instance.vm.options = data.options ? data.options : {};
    }

    // 显示
    instance.vm.show = true;

    // 获取don节点
    instance.dom = instance.vm.$el;

    return instance.vm;
};

/* harmony default export */ __webpack_exports__["a"] = (previewImg);

/***/ }),

/***/ "IQmU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_vue__ = __webpack_require__("u3hq");


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__index_vue__["a" /* default */]);

/***/ }),

/***/ "IlgU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__history_vue__ = __webpack_require__("JNp6");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            ops: {
                vuescroll: {
                    mode: "native"
                },
                sizeStrategy: "number",
                scrollPanel: {
                    // 是否允许x或y方向上的滚动
                    scrollingX: false,
                    scrollingY: true
                },
                scrollContent: {},
                vRail: {}
            },
            ops2: {
                vuescroll: {
                    mode: "native"
                },
                sizeStrategy: "number",
                scrollPanel: {
                    // 是否禁止x或y方向上的滚动
                    scrollingX: false,
                    scrollingY: true
                },
                scrollContent: {},
                vRail: {}
            },

            showPersonal: false,
            info: {}
        };
    },

    components: {
        history: __WEBPACK_IMPORTED_MODULE_0__history_vue__["a" /* default */]
    },
    methods: {
        hiddenNavMethods: function hiddenNavMethods() {
            this.$store.state.hiddenNav = !this.$store.state.hiddenNav;
        },


        //
        openPersonal: function openPersonal() {
            this.getInfo();

            this.showPersonal = true;
        },
        closePersonal: function closePersonal() {
            this.showPersonal = false;
        },
        getInfo: function getInfo() {
            var _this = this;

            this.$reqPost("/api/userInfo/get", {}).then(function (res) {
                _this.info = res.data.returnData;
            }, function (err) {});
        },
        setCenter: function setCenter() {
            var _this2 = this;

            this.$reqPost("/api/user/center/put", {}).then(function (res) {
                _this2.info = res.data.returnData;

                _this2.$message({
                    message: "修改成功!",
                    type: "success"
                });
            }, function (err) {
                _this2.getInfo();
            });
        },
        setWs: function setWs() {
            var _this3 = this;

            this.$reqPost("/api/user/center/ws/put", {}).then(function (res) {
                _this3.info = res.data.returnData;
                _this3.$store.state.user.receiveWebsocketNotify = res.data.returnData.receiveWebsocketNotify;

                _this3.$message({
                    message: "修改成功!",
                    type: "success"
                });
            }, function (err) {
                _this3.getInfo();
            });
        },

        // 判断是否显示,当前菜单所需角色
        show: function show(role) {
            // 如果不需要权限
            if (!role || role.length == 0) {
                return true;
            }
            // 如果需要权限  则判断有没有所需的权限
            if (this.roleIsContained(this.$store.state.user.myRole, role)) {
                return true;
            } else {
                return false;
            }
        },

        // 判断a数组中是否有b数组的数据
        isHave: function isHave(a, b) {
            // 遍历b数组  如果有相同  则返回true
            for (var i = 0; i < b.length; i++) {
                for (var j = 0; j < a.length; j++) {
                    if (b[i] == a[j]) {
                        return true;
                    }
                }
            }
            return false;
        },
        roleIsContained: function roleIsContained(myrole, roles) {
            if (roles.indexOf(myrole) == -1) {
                return false;
            }
            return true;
        },

        // 判断b数组是否包含在a数组中
        isContained: function isContained(a, b) {
            if (!(a instanceof Array) || !(b instanceof Array)) return false;
            if (a.length < b.length) return false;
            var aStr = a.toString();
            for (var i = 0, len = b.length; i < len; i++) {
                if (aStr.indexOf(b[i]) == -1) return false;
            }
            return true;
        },
        clickSuper: function clickSuper(item, index) {
            // 判断有没有子菜单  有 则展开
            if (item.child && item.child.length > 0) {
                var obj = this.$store.state.navigationList[index];
                obj.open = !obj.open;
                this.$set(this.$store.state.navigationList, index, obj);
            }
            //
            if (item.router) {
                this.$clearHistory();
                this.$router.replace(item.router);
            }
        },
        clickChild: function clickChild(item) {
            if (!item.router) {
                return;
            }
            this.$clearHistory();
            this.$router.replace(item.router);
        },
        clickDropdown: function clickDropdown(e) {
            this[e]();
        },
        logout: function logout() {
            var _this4 = this;

            // 清除本地
            this.$reqPost("/api/logout", {}).then(function (res) {
                _this4.$message({
                    message: "您已退出登录"
                });

                localStorage.removeItem("sessionId");

                location.reload();
            }, function (err) {});
        }
    },
    mounted: function mounted() {}
});

/***/ }),

/***/ "JNp6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_history_vue__ = __webpack_require__("FkLF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b7c7ff8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_history_vue__ = __webpack_require__("xQGL");
function injectStyle (ssrContext) {
  __webpack_require__("oxY6")
  __webpack_require__("5KOv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4b7c7ff8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_history_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b7c7ff8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_history_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KNpk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_table_vue__ = __webpack_require__("ahc5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ac61494_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_table_vue__ = __webpack_require__("ZRGb");
function injectStyle (ssrContext) {
  __webpack_require__("wpK1")
  __webpack_require__("XQ8K")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_table_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ac61494_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KnrH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LOkV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_router___ = __webpack_require__("/nV0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_vuex_store__ = __webpack_require__("3hlU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_js_config__ = __webpack_require__("vgQg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("7+uW");







var SIGN_REGEXP = /([yMdhsm])(\1*)/g;
function padding(s, len) {
    var len = len - (s + '').length;
    for (var i = 0; i < len; i++) {
        s = '0' + s;
    }
    return s;
};

var goBack = function goBack() {
    if (this.$store.state.fromUrl) {
        __WEBPACK_IMPORTED_MODULE_2__vue_router___["a" /* default */].go(-1);
    } else {
        __WEBPACK_IMPORTED_MODULE_2__vue_router___["a" /* default */].push({ path: '/' });
    }
};

var debounce = function debounce(func, wait, immediate) {
    var timeout = void 0,
        args = void 0,
        context = void 0,
        timestamp = void 0,
        result = void 0;
    return function () {
        context = this;
        args = arguments;
        timestamp = new Date();
        var later = function later() {
            var last = new Date() - timestamp;
            if (last < wait) {
                timeout = setTimeout(later, wait - last);
            } else {
                timeout = null;
                result = func.apply(context, args);
            }
        };
        if (!timeout) {
            timeout = setTimeout(later, wait);
        }
        return result;
    };
};

var throttle = function throttle(func, wait, options) {
    var timeout, context, args, result;
    var previous = 0;
    if (!options) options = {};

    var later = function later() {
        previous = options.leading === false ? 0 : new Date();
        timeout = null;
        result = func.apply(context, args);
        if (!timeout) context = args = null; //显示地释放内存，防止内存泄漏
    };

    var throttled = function throttled() {
        var now = new Date();
        if (!previous && options.leading === false) previous = now;
        var remaining = wait - (now - previous);
        context = this;
        args = arguments;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            result = func.apply(context, args);
            if (!timeout) context = args = null;
        } else if (!timeout && options.trailing !== false) {
            timeout = setTimeout(later, remaining);
        }
        return result;
    };

    throttled.cancel = function () {
        clearTimeout(timeout);
        previous = 0;
        timeout = context = args = null;
    };
    return throttled;
};

var IsPC = function IsPC() {
    var userAgentInfo = navigator.userAgent;
    var Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
    var flag = true;
    for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break;
        }
    }
    return flag;
};

var getELTime = function getELTime(value, format) {
    if (!value) {
        return '';
    }
    // value = value.replace('T', ' ');
    switch (typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(value)) {
        case "string":
            value = new Date(value.replace(/-/g, "/"));
            break;
        case "number":
            value = new Date(value);
            break;
    }
    if (!value instanceof Date) return '';
    var dict = {
        "yyyy": value.getFullYear(),
        "MM": ("" + (value.getMonth() + 101)).substr(1),
        "dd": ("" + (value.getDate() + 100)).substr(1),
        "HH": ("" + (value.getHours() + 100)).substr(1),
        "mm": ("" + (value.getMinutes() + 100)).substr(1),
        "ss": ("" + (value.getSeconds() + 100)).substr(1),
        "M": value.getMonth() + 1,
        "d": value.getDate(),
        "H": value.getHours(),
        "m": value.getMinutes(),
        "s": value.getSeconds()

    };
    for (var k in dict) {
        if (format.indexOf(k) >= 0) {
            format = format.replace(k, dict[k]);
        }
    }
    return format;
};

var isAdmin = function isAdmin() {
    if (!this.$store.state.user.roles) {
        return false;
    }
    for (var i = 0; i < this.$store.state.user.roles.length; i++) {
        if (this.$store.state.user.roles[i] == 'sysAdmin') {
            return true;
        }
    }
    return false;
};

var guid = function guid(len) {
    //时间戳
    var time = new Date().getTime() + "";

    var chars = '0123456789abcdefghigklmnopqrstuvwxyzABCDEFGHIGKLMNOPQRSTUVWXYZ'.split(''),
        radix = chars.length,
        qutient = [],
        arr = [];

    //因为时间戳的前几位较为固定 所以将其倒转过来
    qutient = parseInt(time.split("").reverse().join(""));

    do {
        var mod = qutient % radix;
        qutient = (qutient - mod) / radix;
        arr.unshift(chars[mod]);
    } while (qutient);

    //时间戳生成的62进制最大为八位  不足八位则补足  并在最后一位标记补足的位数
    var num = 0;
    for (var i = 0; i < 8 - arr.length; i++) {
        num++;
        arr.push(chars[0 | Math.random() * radix]);
    }
    arr.push(num + '');

    //当前arr为9位(1位时间戳+1位标记)
    //生成9位随机字符插入其中
    var guArr = [];
    for (var j = 0; j < 9; j++) {
        guArr.push(chars[0 | Math.random() * radix]);
        guArr.push(arr[j]);
    }

    // 当前guArr为18位
    if (!len || len <= 18) {
        //如果小于等于18  则直接返回
    } else {
        //大于18 则要在后面加上随机字符串
        for (var k = 0; k < len - 18; k++) {
            guArr.push(chars[0 | Math.random() * radix]);
        }
    }

    return guArr.join('');
};

var guidTime = function guidTime(format) {
    var value = new Date();
    if (!format) {
        format = "yyyyMMdd";
    }

    switch (typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(value)) {
        case "string":
            value = new Date(value.replace(/-/g, "/"));
            break;
        case "number":
            value = new Date(value);
            break;
    }
    if (!value instanceof Date) return '';
    var dict = {
        "yyyy": value.getFullYear(),
        "MM": ("" + (value.getMonth() + 101)).substr(1),
        "dd": ("" + (value.getDate() + 100)).substr(1),
        "HH": ("" + (value.getHours() + 100)).substr(1),
        "mm": ("" + (value.getMinutes() + 100)).substr(1),
        "ss": ("" + (value.getSeconds() + 100)).substr(1),
        "M": value.getMonth() + 1,
        "d": value.getDate(),
        "H": value.getHours(),
        "m": value.getMinutes(),
        "s": value.getSeconds()

    };
    for (var k in dict) {
        if (format.indexOf(k) >= 0) {
            format = format.replace(k, dict[k]);
        }
    }
    return format;
};

var newPassword = function newPassword() {
    var len = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;

    if (!len || len < 3) {
        console.error('密码长度不得低于3位');
        return;
    }

    var chars = '0123456789abcdefghigklmnopqrstuvwxyzABCDEFGHIGKLMNOPQRSTUVWXYZ'.split(''),
        big = 'ABCDEFGHIGKLMNOPQRSTUVWXYZ'.split(''),
        small = 'abcdefghigklmnopqrstuvwxyz'.split(''),
        numbers = '0123456789'.split(''),
        arr = [];

    for (var i = 0; i < len; i++) {
        var c = chars[Math.floor(Math.random() * chars.length)];
        arr.push(c);
    }

    //随机选取一个大写字符 小写字符 和数字
    var b = big[Math.floor(Math.random() * big.length)];
    var s = small[Math.floor(Math.random() * small.length)];
    var n = numbers[Math.floor(Math.random() * numbers.length)];

    //替换三个原有的字符  先获取三个index
    var index1 = void 0,
        index2 = void 0,
        index3 = void 0;

    index1 = Math.floor(Math.random() * len);

    for (; index2 === undefined;) {
        var a = Math.floor(Math.random() * len);
        if (a !== index1) {
            index2 = a;
        }
    }
    for (; index3 === undefined;) {
        var _a = Math.floor(Math.random() * len);
        if (_a !== index1 && _a !== index2) {
            index3 = _a;
        }
    }

    //然后替换
    arr[index1] = b;
    arr[index2] = s;
    arr[index3] = n;

    //转成字符串
    return arr.join('');
};

var addHistory = function addHistory(path, query) {
    var arr = __WEBPACK_IMPORTED_MODULE_3__vue_vuex_store__["a" /* default */].state.historyList;

    //添加当前页面 如果已经有了  就不再添加一个了
    var obj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_2__vue_router___["a" /* default */].history.current);
    var tips = true;
    for (var i = 0; i < arr.length; i++) {
        if (arr[i].meta.navName == obj.meta.navName) {
            tips = false;
        }
    }
    if (tips) {
        __WEBPACK_IMPORTED_MODULE_3__vue_vuex_store__["a" /* default */].state.historyList.push(obj);
    }

    //添加目标页面 如果已经有了  就不再添加一个了
    var obj2 = {};
    // 先找到对象
    for (var _i = 0; _i < __WEBPACK_IMPORTED_MODULE_2__vue_router___["a" /* default */].options.routes.length; _i++) {
        if (path == __WEBPACK_IMPORTED_MODULE_2__vue_router___["a" /* default */].options.routes[_i].path) {
            obj2 = __WEBPACK_IMPORTED_MODULE_2__vue_router___["a" /* default */].options.routes[_i];
        }
    }

    var tips2 = true;
    for (var _i2 = 0; _i2 < arr.length; _i2++) {
        if (arr[_i2].meta.navName == obj2.meta.navName) {
            tips2 = false;
        }
    }
    if (tips2) {
        __WEBPACK_IMPORTED_MODULE_3__vue_vuex_store__["a" /* default */].state.historyList.push(obj2);
    }

    __WEBPACK_IMPORTED_MODULE_2__vue_router___["a" /* default */].push(path + query);
};

var clearHistory = function clearHistory() {
    __WEBPACK_IMPORTED_MODULE_3__vue_vuex_store__["a" /* default */].state.historyList = [];
};

var noRefresh = function noRefresh() {
    var obj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_2__vue_router___["a" /* default */].history.current);
    if (obj.query.refresh == 'no') {
        __WEBPACK_IMPORTED_MODULE_2__vue_router___["a" /* default */].replace(obj.path);
        return true;
    } else {
        return false;
    }
};
var downLoad = function downLoad(id) {
    __WEBPACK_IMPORTED_MODULE_5_vue__["default"].prototype.$reqPost("/api/file/downloadCode/get", {
        id: id
    }).then(function (res) {
        if (res.data.returnData) {
            var str = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__assets_js_config__["a" /* url */])().baseUrl + '/api/file/downloadFile';

            //JavaScript版
            var f = document.createElement("form");
            document.body.appendChild(f);

            var i = document.createElement("input");
            i.type = "hidden";
            f.appendChild(i);
            i.value = res.data.returnData;
            i.name = "code";

            f.action = str; //下载的url 地址
            f.submit();

            document.body.removeChild(f);
        }
    }, function (err) {});
};

/* harmony default export */ __webpack_exports__["a"] = ({
    install: function install(Vue) {
        Vue.prototype.$goBack = goBack, Vue.prototype.$debounce = debounce, Vue.prototype.$throttle = throttle, Vue.prototype.$IsPC = IsPC, Vue.prototype.$getELTime = getELTime, Vue.prototype.$isAdmin = isAdmin, Vue.prototype.$guid = guid, Vue.prototype.$guidTime = guidTime, Vue.prototype.$newPassword = newPassword, Vue.prototype.$addHistory = addHistory, Vue.prototype.$clearHistory = clearHistory, Vue.prototype.$downLoad = downLoad, Vue.prototype.$noRefresh = noRefresh;
    }
});

/***/ }),

/***/ "LtSP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__ = __webpack_require__("HSQo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_js_config__ = __webpack_require__("vgQg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vue_vuex_store__ = __webpack_require__("3hlU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__vue_router___ = __webpack_require__("/nV0");










var instance = __WEBPACK_IMPORTED_MODULE_4_axios___default.a.create({
    timeout: 60000,
    baseURL:  false ? "" : "",
    withCredentials: true // 允许携带cookie
});
// Toast.allowMultiple();
instance.interceptors.request.use(function (config) {
    if (config.method === 'post' || config.method === 'put') {
        config.headers["Content-Type"] = "application/json;";

        var sessionId = localStorage.getItem('sessionId');

        if (sessionId) {
            config.headers["x-auth-token"] = sessionId;
        }

        config.headers["channel"] = "app";

        config.data = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(config.data);
    }
    // if (!config.headers.Authorization) {
    //     config.headers.Authorization = 'Bearer ' + (window.localStorage.getItem('Authorization') || '');
    // }
    return config;
}, function (err) {
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(err);
});

instance.interceptors.response.use(function (res) {
    if (res.data.code != 0) {
        if (res.data.code == 700) {
            //当前用户未登录

            if (window.location.href.search("window") != "-1") {
                return;
            }

            __WEBPACK_IMPORTED_MODULE_6_vue__["default"].prototype.$message.error("登录已过期 请重新登录!");

            setTimeout(function () {
                __WEBPACK_IMPORTED_MODULE_8__vue_router___["a" /* default */].replace('/login');
            }, 1000);
        } else {
            // 设置了hiddenError的不提示
            if (!res.config.hiddenError && res && res.data && res.data.errorMessage) {
                __WEBPACK_IMPORTED_MODULE_6_vue__["default"].prototype.$message.error(res.data.errorMessage);
            }
        }
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(res);
    }
    return res;
}, function (error) {
    if (error.message.indexOf('timeout of') >= 0) {
        __WEBPACK_IMPORTED_MODULE_6_vue__["default"].prototype.$message.error("请求超时！");
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(error);
    }
    // Vue.prototype.$message.error("请求出现错误！");
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(error);
});

var post = function post(reqUrl, data) {
    var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var authToken = arguments[3];

    reqUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__assets_js_config__["a" /* url */])().baseUrl + reqUrl;

    // let appId = store.state.appId
    // data.appId = appId

    return instance.post(reqUrl, data, config, authToken);
};

var put = function put(url, data) {
    var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    return instance.put(url, data, config);
};

var get = function get(url, params) {
    var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    reqUrl = url().baseUrl + reqUrl;
    return instance.get(reqUrl, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
        params: params
    }, config));
};

var deleteMethod = function deleteMethod(url) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return instance(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
        url: url,
        method: 'delete'
    }, config));
};

/* harmony default export */ __webpack_exports__["a"] = ({
    install: function install(Vue) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default()(Vue.prototype, {
            $reqGet: {
                value: get
            },
            $reqPost: {
                value: post
            },
            $reqPut: {
                value: put
            },
            $reqDel: {
                value: deleteMethod
            }
        });
    }
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9de380c0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("Ve0e");
function injectStyle (ssrContext) {
  __webpack_require__("V02v")
  __webpack_require__("TGU+")
  __webpack_require__("YEU2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9de380c0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9de380c0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MUd3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"json-type-com"},[(_vm.showData.error)?_c('div',{staticClass:"error"},[_vm._v("ERROR：无法解析的信息。")]):(_vm.showData.type == 'table')?_c('v-table',{attrs:{"isPage":_vm.isPage,"json":_vm.showData}}):_c('div',{staticClass:"error"},[_vm._v("ERROR：不支持的消息类型。")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "N1kN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_scss_iconfont_iconfont_css__ = __webpack_require__("z2xj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_scss_iconfont_iconfont_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_scss_iconfont_iconfont_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App_vue__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_router___ = __webpack_require__("/nV0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vue_vuex_store__ = __webpack_require__("3hlU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_polyfill__ = __webpack_require__("j1ja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vue_plugins_axios__ = __webpack_require__("LtSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_js_util__ = __webpack_require__("LOkV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__vue_filter___ = __webpack_require__("3U+z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_font_awesome_css_font_awesome_css__ = __webpack_require__("5W1q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_font_awesome_css_font_awesome_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_font_awesome_css_font_awesome_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_js_WeiXin_js__ = __webpack_require__("5Qfy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__vue_mixin_mixin__ = __webpack_require__("Dpyr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__vue_mixin_hidden_nav_mixin__ = __webpack_require__("YtrL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_index_css__ = __webpack_require__("tvR6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__vue_components_nav2__ = __webpack_require__("nNGG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__vue_components_dragImgUpload__ = __webpack_require__("ViVI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__vue_components_wxChat__ = __webpack_require__("RuFL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vuescroll__ = __webpack_require__("8/7D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vuescroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vuescroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vuescroll_dist_vuescroll_css__ = __webpack_require__("YzDh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vuescroll_dist_vuescroll_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vuescroll_dist_vuescroll_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_v_viewer__ = __webpack_require__("EAZf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_v_viewer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_v_viewer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_viewerjs_dist_viewer_css__ = __webpack_require__("N1kN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_viewerjs_dist_viewer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_viewerjs_dist_viewer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__vue_components_plugIn___ = __webpack_require__("w3wo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__vue_components_RTF_index_vue__ = __webpack_require__("Y7SJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__vue_components_treeSelect_treeSelect_vue__ = __webpack_require__("wkuv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_v_charts__ = __webpack_require__("vO7p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_v_charts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_v_charts__);




































__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component("v-rtf", __WEBPACK_IMPORTED_MODULE_24__vue_components_RTF_index_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component("v-nav", __WEBPACK_IMPORTED_MODULE_16__vue_components_nav2__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component("v-drag-img-upload", __WEBPACK_IMPORTED_MODULE_17__vue_components_dragImgUpload__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component("wxChat", __WEBPACK_IMPORTED_MODULE_18__vue_components_wxChat__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component("v-tree-select", __WEBPACK_IMPORTED_MODULE_25__vue_components_treeSelect_treeSelect_vue__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_23__vue_components_plugIn___["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_19_vuescroll___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_21_v_viewer___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_12__vue_mixin_mixin__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_13__vue_mixin_hidden_nav_mixin__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_26_v_charts___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.debug = true;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.devtools = true;

// plugins
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7__vue_plugins_axios__["a" /* default */]);

// vue
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11__assets_js_WeiXin_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9__vue_filter___["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8__assets_js_util__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* default */]);

// ElementUI
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_element_ui___default.a);

new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_3__vue_router___["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_5__vue_vuex_store__["a" /* default */],
    created: function created() {},

    render: function render(h) {
        return h(__WEBPACK_IMPORTED_MODULE_2__App_vue__["a" /* default */]);
    }
});

/***/ }),

/***/ "NUEj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Quill) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_quill_editor__ = __webpack_require__("G0J2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_quill_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_quill_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__com_dragImgUpload_vue__ = __webpack_require__("QK7r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_quill_dist_quill_core_css__ = __webpack_require__("3f40");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_quill_dist_quill_core_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_quill_dist_quill_core_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_quill_dist_quill_snow_css__ = __webpack_require__("4qOc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_quill_dist_quill_snow_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_quill_dist_quill_snow_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_quill_dist_quill_bubble_css__ = __webpack_require__("+cgv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_quill_dist_quill_bubble_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_quill_dist_quill_bubble_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_quill_image_resize_module__ = __webpack_require__("AJTU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_quill_image_resize_module___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_quill_image_resize_module__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 //调用编辑器
 //上传







Quill.register("modules/imageResize", __WEBPACK_IMPORTED_MODULE_7_quill_image_resize_module___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        quillEditor: __WEBPACK_IMPORTED_MODULE_2_vue_quill_editor__["quillEditor"],
        dragImgUpload: __WEBPACK_IMPORTED_MODULE_3__com_dragImgUpload_vue__["a" /* default */]
    },
    props: {
        height: {
            type: Number,
            required: false
        },
        topHeight: {
            type: Number,
            required: false
        },
        refData: {
            type: String,
            required: false
        }
    },
    watch: {
        content: function content() {
            this.$emit("change", this.content);
        },
        refData: function refData() {
            this.content = this.refData;
        }
    },
    data: function data() {
        return {
            content: "",
            options: {
                theme: "snow",
                modules: {
                    toolbar: [[], ["bold", "italic", "underline", "strike"], ["blockquote", "code-block"], [{ list: "ordered" }, { list: "bullet" }], [{ script: "sub" }, { script: "super" }], [{ indent: "-1" }, { indent: "+1" }], [{ direction: "rtl" }], [{ header: [1, 2, 3, 4, 5, 6, false] }], [{ color: [] }, { background: [] }], [{ font: [] }], [{ align: [] }], ["clean"], ["image"]],
                    history: {
                        delay: 1000,
                        maxStack: 50,
                        userOnly: false
                    },
                    imageResize: {}
                }
            }
        };
    },

    methods: {
        // 抛出图片上传事件
        uploaderFileChange: function uploaderFileChange(e) {
            this.$emit("uploaderFileChange", e.files[0]);
        },
        onRead: function onRead(input) {
            var img = input.target.files;

            if (img.length == 0) {
                return;
            }
            for (var i = 0; i < img.length; i++) {
                this.$emit("uploaderFileChange", img[i]);
            }

            // 清空
            input.srcElement.value = "";
        },

        // 添加图片2
        addImg: function addImg(url) {
            var quill = this.$refs.quill.quill;
            var index = (quill.getSelection() || {}).index || 0;
            // 添加一个图片
            quill.insertEmbed(index, "image", url);
            // 修改光标位置
            quill.setSelection(index + 1);
        },
        onEditorReady: function onEditorReady(editor) {
            // 准备编辑器
        },
        onEditorBlur: function onEditorBlur() {},
        // 失去焦点事件
        onEditorFocus: function onEditorFocus() {},
        // 获得焦点事件
        onEditorChange: function onEditorChange() {} // 内容改变事件

    },
    mounted: function mounted() {
        var vm = this;
        var imgHandler = function () {
            var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(state) {
                var fileInput;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (state) {
                                    fileInput = vm.$refs.quillImgInput;

                                    fileInput.click(); // 加一个触发事件
                                }

                            case 1:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            return function imgHandler(_x) {
                return _ref.apply(this, arguments);
            };
        }();
        this.$refs.quill.quill.getModule("toolbar").addHandler("image", imgHandler);

        this.$nextTick(function () {
            if (this.height) {
                var rtf = this.$refs.RTF;

                var dom = rtf.getElementsByClassName("ql-container")[0];
                dom.style.height = this.height + "px";
            }
            if (this.topHeight) {
                var _rtf = this.$refs.RTF;

                var _dom = _rtf.getElementsByClassName("ql-toolbar")[0];
                _dom.style.height = this.topHeight + "px";
            }
        });
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("yPE/")))

/***/ }),

/***/ "O37J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var chat = function chat() {
    return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, "N3cY"));
};
var statistics = function statistics() {
    return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, "9uTl"));
};

/* harmony default export */ __webpack_exports__["a"] = ([
// 聊天
{
    path: "/chat",
    name: "chat",
    components: {
        default: chat
    },
    meta: {
        nav: "chat",
        navChild: "chat",
        navName: "聊天记录",
        keepAlive: true
    }
}, {
    path: "/chat/statistics",
    name: "statistics",
    components: {
        default: statistics
    },
    meta: {
        nav: "chat",
        navChild: "statistics",
        navName: "对话统计",
        keepAlive: true
    }
}]);

/***/ }),

/***/ "OU2i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.show)?_c('div',{ref:"back",staticClass:"plugin-previewImg-back",on:{"mousedown":_vm.mousedown,"click":_vm.close}},[_vm._l((_vm.imgList),function(item,i){return (i == _vm.index)?_c('div',{key:i,staticClass:"plugin-previewImg-img-con"},[_c('img',{ref:"img",refInFor:true,staticClass:"plugin-previewImg-img",staticStyle:{"transform":"translateX(0px) translateY(0px)"},attrs:{"src":item,"alt":""},on:{"dragstart":function($event){$event.preventDefault();},"click":function($event){$event.stopPropagation();}}})]):_vm._e()}),_vm._v(" "),_c('div',{staticClass:"plugin-previewImg-close",on:{"click":function($event){$event.stopPropagation();return _vm.close($event)}}},[_c('i',{staticClass:"el-icon-close"})]),_vm._v(" "),(_vm.imgList.length > 1)?_c('div',{staticClass:"plugin-previewImg-btn plugin-previewImg-left",on:{"click":function($event){$event.stopPropagation();return _vm.prev($event)}}},[_c('i',{staticClass:"el-icon-arrow-left"})]):_vm._e(),_vm._v(" "),(_vm.imgList.length > 1)?_c('div',{staticClass:"plugin-previewImg-btn plugin-previewImg-right",on:{"click":function($event){$event.stopPropagation();return _vm.next($event)}}},[_c('i',{staticClass:"el-icon-arrow-right"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"plugin-previewImg-index"},[_c('span',[_vm._v(_vm._s(_vm.index + 1))]),_vm._v(" "),_c('span',[_vm._v("/")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.imgList.length))])])],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PLgo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getters = {
  // getCount: state => state.count,
};

/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),

/***/ "PqyU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QK7r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dragImgUpload_vue__ = __webpack_require__("xC70");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6638760d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dragImgUpload_vue__ = __webpack_require__("jfM7");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dragImgUpload_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6638760d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dragImgUpload_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QT8i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qn33":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAD90lEQVRoQ+2ZQWwUVRjH/9/szkwLlCgaE+NpiyEYPYBJOXBCQme609akmnLQhNiLelgSNQEOQCgRD2qiB/agB4Mx0QONNKTsbHfaACcSbQIcIBpDpYYYD0higNLuzM58ZmshrbudeW87wy5JJ9nT/N/3/X/vP2/2zQzhCT/oCfePNYBmJ7iWQFgCrmO9w6BZ3SiMJJVUYgm4jvUegK8Wjb+vGfbXSUAkAsAXdqU9b90UgG2Lpq+q6oMueu1iJW6IRADciWwOTCeXmSXer3UX8y0PwJcG2737D6YAfnm5WbqubljXRTtH5uKEiD0Bd8L6EIwv6pokfKR121+2LADb2Y1emqrX/pYVTP6mVriLrOLduCBiTcBzsgcZ9GmYOQIfUo3iZy0HcHes/9k2PfgZ4Ey4Obo5X1Z2bOwf+zsOiNgSKJesI0T4WMQUM47qpn1CRBuliQVgdtx8Pq2kpgh4Iaph9TwDf1YCv2t9T+kvEX34JbnaCgBcJ3saoEG5UjyiGcW9cmNq1UIJXDs9qL3YcS+TUpUMM2U4CDoBypBCGWLOMPB0g0b+ATBDhBmAZnw/+CNNmPZ9TGv3N9ygvSNuVN0agNtnX+/oaPfeVQhbEFAnCJ3Awq8ZxwwYNwG6AeAnzSx8838TNQBzxZ5dqZRyoRluo3oy47hu2sNLdTUAlUmrLwgwFlWsSeeHNMP+NhSgerJcsoaJcKxJJuu2rTf7VeGKi7iVIFYyHwrQKkmEmY8EaDZElHkhgGZBiJgXBnjcEKLmpQAeFwQRhtVu+7joHVBoK7G0WJJ3J1nz0gk8BHEd6w6ATaKzJKRj3NZM+zkh7RKRdALVsa7Te632oV22dc2u5rpmFF6RrdIggBWE/QnKmljUs2bYiuxYaYByqX8rkf+LbCMRPXPqJd0c+1VE+1AjD1DsfYNS/KNME1Et+/Smni2cEdU3tIi9id7DzBzL82zNKiA6onYXPkkUoFyyvifCWzJNRLXM+EE37bdF9Q0l4DrWZQDbZZpIaK9ohv2qhF7+E5PrWPMA9MgmhFN+JfiuqkullX1gDEWOAcqaYbcJ6B5JpBbx/GRvpxLwdFgDBo8GjHy7WTy/VDdXyu5WCDkCDYSNDxTa3Lan8LsohBxAyepTqP7jJgHnCUo+bZwbDWtecfoGGEGOgd31dAGjv820zyUC4JWsA0xY/l6T+TKY8lqPfUq0aVXnjltDIM6BaNk1T4yDqml/LlpLKgFvwjrGjP/eChCmAcqr6dl8o19eFr7kVNbnAM6BsXmhbNK70fnx7AdE9JSW0k/SntHqpm7VB08OPOP65f0EulXv3U9YA6kEVu00gQJrAAlMqlTJtQSkpisB8b9K1FdAaKTcoQAAAABJRU5ErkJggg=="

/***/ }),

/***/ "RuFL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wxChat_vue__ = __webpack_require__("on3G");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23541632_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_wxChat_vue__ = __webpack_require__("r7cV");
function injectStyle (ssrContext) {
  __webpack_require__("QT8i")
  __webpack_require__("B/Tc")
  __webpack_require__("PqyU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-23541632"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wxChat_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23541632_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_wxChat_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "S0bA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var window = function window() {
    return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "bl8W"));
};

/* harmony default export */ __webpack_exports__["a"] = ([
// 客服
{
    path: "/window",
    name: "window",
    components: {
        default: window
    },
    meta: {
        nav: "window",
        navChild: "",
        navName: "接待中",
        keepAlive: false,
        hiddenNavigation: true
    }
}]);

/***/ }),

/***/ "S5Ji":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,77u/PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNTYiIGhlaWdodD0iMjU2IiB2aWV3Qm94PSIwIDAgNDggNDgiIGZpbGw9InJnYmEoNjQsIDE1OCwgMjU1LCAxKSI+CiAgICA8cGF0aCBkPSJNMCAwaDQ4djQ4SDB6IiBmaWxsPSJub25lIj48L3BhdGg+CiAgICA8cGF0aCBkPSJNMjggNEgxMkM5Ljc5IDQgOC4wMiA1Ljc5IDguMDIgOEw4IDQwYzAgMi4yMSAxLjc3IDQgMy45OCA0SDM2YzIuMjEgMCA0LTEuNzkgNC00VjE2TDI4IDR6bTQgMzJIMTZ2LTRoMTZ2NHptMC04SDE2di00aDE2djR6bS02LTEwVjdsMTEgMTFIMjZ6Ij48L3BhdGg+Cjwvc3ZnPg=="

/***/ }),

/***/ "SE3I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main_vue__ = __webpack_require__("HN0E");



var MessageConstructor = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_1__main_vue__["a" /* default */]);

var instance = void 0;

var openMenu = function openMenu(e, list) {

    // 防止空数组
    if (!list || !list.array || list.array.length <= 0) {
        return;
    }
    // 防止没有text   j为空text数量
    var j = 0;
    for (var i = 0; i < list.array.length; i++) {
        if (!list.array[i].text) {
            j++;
        }
    }
    if (j >= list.array.length) {
        return;
    }

    if (!instance) {
        instance = new MessageConstructor();
        instance.vm = instance.$mount();
    }

    document.body.appendChild(instance.vm.$el);

    // 传入事件
    instance.vm.e = e;
    instance.vm.list = list;

    // 显示
    instance.vm.show = true;

    // 获取don节点
    instance.dom = instance.vm.$el;

    // intit
    instance.vm.init();

    return instance.vm;
};

/* harmony default export */ __webpack_exports__["a"] = (openMenu);

/***/ }),

/***/ "SOiF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("444")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TGU+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V02v":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VIVP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var setting = function setting() {
    return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, "goBv"));
};

/* harmony default export */ __webpack_exports__["a"] = ([
// 设置
{
    path: "/historyTag",
    name: "historyTag",
    components: {
        default: setting
    },
    meta: {
        nav: "historyTag",
        navName: "会话标签",
        keepAlive: true
    }
}]);

/***/ }),

/***/ "Ve0e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(
            this.$store.state.user.sessionId ||
            this.$route.name == 'login' ||
            this.$route.name == 'window'
        )?_c('div',{staticClass:"router-view"},[(_vm.$route.meta.hiddenNavigation)?[_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view',{staticClass:"view-router",staticStyle:{"height":"100vh","overflow":"hidden"}}):_vm._e()],1),_vm._v(" "),(!_vm.$route.meta.keepAlive)?_c('router-view',{staticClass:"view-router",staticStyle:{"height":"100vh","overflow":"hidden"}}):_vm._e()]:[_c('v-nav'),_vm._v(" "),_c('div',[_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view',{staticClass:"view-router",staticStyle:{"height":"100vh","overflow":"hidden"}}):_vm._e()],1),_vm._v(" "),(!_vm.$route.meta.keepAlive)?_c('router-view',{staticClass:"view-router",staticStyle:{"height":"100vh","overflow":"hidden"}}):_vm._e()],1)]],2):_c('div',[_vm._v("您当前未登录")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ViVI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dragImgUpload_vue__ = __webpack_require__("pVSU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ef5a205c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dragImgUpload_vue__ = __webpack_require__("FknX");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dragImgUpload_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ef5a205c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dragImgUpload_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VoG2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WCZ/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Whin":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.show)?_c('div',{ref:"back",staticClass:"plugin-menu-back",on:{"click":_vm.close,"contextmenu":function($event){$event.preventDefault();return _vm.close($event)}}},[_c('div',{staticClass:"plugin-menu-con",style:(("position:absolute;left:" + (_vm.e.clientX) + "px;top:" + (_vm.e.clientY) + "px;"))},_vm._l((_vm.list.array),function(item,index){return (item.text)?_c('div',{key:'plugin-menu-item' + index,staticClass:"plugin-menu-item",style:(("color:" + (item.color) + ";")),on:{"click":function($event){$event.stopPropagation();_vm.click(item,index)}}},[_vm._v(_vm._s(item.text))]):_vm._e()}))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XQ8K":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Y7SJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("NUEj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71be68a1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("HO0p");
function injectStyle (ssrContext) {
  __webpack_require__("VoG2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-71be68a1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71be68a1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YEU2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YtrL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// 全局
/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {};
    },
    mounted: function mounted() {},

    watch: {
        "$store.state.hiddenNav": function $storeStateHiddenNav() {
            var page = this.$refs.page;

            if (page) {
                if (this.$store.state.hiddenNav) {
                    page.classList.add("hidden-nav-page");
                } else {
                    page.classList.remove("hidden-nav-page");
                }
            }
        }
    },
    created: function created() {}
});

/***/ }),

/***/ "YzDh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZLYb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("CxY5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ee8817a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("MUd3");
function injectStyle (ssrContext) {
  __webpack_require__("xUON")
  __webpack_require__("m+mu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ee8817a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZRGb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-com"},[_c('div',{staticClass:"describe"},[_vm._v("发送了表格，您可以：")]),_vm._v(" "),_c('div',{staticClass:"tools-bar"},[(_vm.showType == 1 && _vm.chartColumns && _vm.chartColumns.length > 1)?_c('div',{staticClass:"btn",on:{"click":function($event){_vm.showType = 2}}},[_c('i',{staticClass:"el-icon-s-data icon"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("查看柱状图")])]):_vm._e(),_vm._v(" "),(_vm.showType == 2)?_c('div',{staticClass:"btn",on:{"click":function($event){_vm.showType = 1}}},[_c('i',{staticClass:"el-icon-s-grid icon"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("查看数据表")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.showType == 1)?_c('div',[_c('el-table',{attrs:{"data":_vm.list,"border":"","show-summary":!!(_vm.summaryKeys && _vm.summaryKeys.length),"summary-method":_vm.summaryMethod}},_vm._l((_vm.list[0]),function(value,key,index){return _c('el-table-column',{key:key + index,attrs:{"label":key,"prop":key}})}))],1):(_vm.showType == 2)?_c('div',[_c('ve-chart',{attrs:{"extend":_vm.chartExtend,"colors":_vm.colors,"data":_vm.chartData,"settings":_vm.chartSettings}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ahc5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: "vTable",
    props: {
        isPage: {
            type: Boolean,
            default: false
        },
        json: {
            type: Object,
            required: true
        }
    },
    data: function data() {
        return {
            showType: 1, //1表格  2图
            // 图
            chartExtend: {
                series: {}
            },
            colors: ["#34a853", "#fbbc05", "#ea4335", "#4285f4", "#585455"],
            chartSettings: {
                type: "histogram"
            }
        };
    },

    computed: {
        chartData: function chartData() {
            var list = this.list;

            var data = {
                columns: this.chartColumns
            };

            data.rows = list;

            return data;
        },


        /**
         * 下面为传入的数据
         */
        // 类型  table
        type: function type() {
            return this.json.type;
        },

        // 标题  String  为空则不显示
        title: function title() {
            return this.json.title;
        },

        // 表格上的合计列  Array[String]  为空则不显示合计
        summaryKeys: function summaryKeys() {
            return this.json.summaryKeys;
        },

        // 柱状图的 横坐标 / 纵坐标(纵坐标可为多个)   Array[String]  为空则不能转换Wie柱状图
        chartColumns: function chartColumns() {
            return this.json.chartColumns;
        },

        // 表格内容  Array[Object]  必传
        list: function list() {
            return this.json.list;
        }
    },
    beforeDestroy: function beforeDestroy() {},
    created: function created() {},

    methods: {
        summaryMethod: function summaryMethod(obj) {
            var arr = [];

            for (var i = 0, len = obj.columns.length; i < len; i++) {
                if (i == 0) {
                    arr.push("合计");
                } else if (this.inArr(obj.columns[i].label, this.summaryKeys)) {
                    arr.push(1);
                } else {
                    arr.push("");
                }
            }

            return arr;
        },
        inArr: function inArr(text, arr) {
            for (var i = 0, len = arr.length; i < len; i++) {
                if (text == arr[i]) {
                    return true;
                }
            }
            return false;
        },
        openWindow: function openWindow() {
            var url = window.location.href.split("#")[0];
            url += "#/jsonTypePage";
            url += "?json=" + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.json);
            this.$openWindow(url);
        }
    }
});

/***/ }),

/***/ "asmb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bggx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var mutations = {
  // 登录凭证
  sessionId: function sessionId(state, status) {
    state.sessionId = status;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),

/***/ "eajV":
/***/ (function(module, exports) {

module.exports = {"_args":[["websocket@1.0.34","/usr/src/app"]],"_from":"websocket@1.0.34","_id":"websocket@1.0.34","_inBundle":false,"_integrity":"sha512-PRDso2sGwF6kM75QykIesBijKSVceR6jL2G8NGYyq2XrItNC2P5/qL5XeR056GhA+Ly7JMFvJb9I312mJfmqnQ==","_location":"/websocket","_optional":true,"_phantomChildren":{"ms":"2.0.0"},"_requested":{"type":"version","registry":true,"raw":"websocket@1.0.34","name":"websocket","escapedName":"websocket","rawSpec":"1.0.34","saveSpec":null,"fetchSpec":"1.0.34"},"_requiredBy":["/stompjs"],"_resolved":"https://registry.npmjs.org/websocket/-/websocket-1.0.34.tgz","_spec":"1.0.34","_where":"/usr/src/app","author":{"name":"Brian McKelvey","email":"theturtle32@gmail.com","url":"https://github.com/theturtle32"},"browser":"lib/browser.js","bugs":{"url":"https://github.com/theturtle32/WebSocket-Node/issues"},"config":{"verbose":false},"contributors":[{"name":"Iñaki Baz Castillo","email":"ibc@aliax.net","url":"http://dev.sipdoc.net"}],"dependencies":{"bufferutil":"^4.0.1","debug":"^2.2.0","es5-ext":"^0.10.50","typedarray-to-buffer":"^3.1.5","utf-8-validate":"^5.0.2","yaeti":"^0.0.6"},"description":"Websocket Client & Server Library implementing the WebSocket protocol as specified in RFC 6455.","devDependencies":{"buffer-equal":"^1.0.0","gulp":"^4.0.2","gulp-jshint":"^2.0.4","jshint":"^2.0.0","jshint-stylish":"^2.2.1","tape":"^4.9.1"},"directories":{"lib":"./lib"},"engines":{"node":">=4.0.0"},"homepage":"https://github.com/theturtle32/WebSocket-Node","keywords":["websocket","websockets","socket","networking","comet","push","RFC-6455","realtime","server","client"],"license":"Apache-2.0","main":"index","name":"websocket","repository":{"type":"git","url":"git+https://github.com/theturtle32/WebSocket-Node.git"},"scripts":{"gulp":"gulp","test":"tape test/unit/*.js"},"version":"1.0.34"}

/***/ }),

/***/ "fNIT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iNnk":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAJlQTFRFAAAAwMDAwcHBwcHBwcHBwcHBwcHBwsLCwcHBwsLCwcHBwcHBwMDAwMDAwcHBwsLCwcHBwsLCwMDAwcHBwcHB////wsLCycnJwcHBwcHBwMDAwsLCv7+/wsLCw8PDwMDAwcHBwMDAwMDAwcHBv7+/wsLCwcHBwcHBwcHBwcHBwsLCwMDAwsLCwsLCwcHBwcHBwcHBwcHBwcHBu1J8EwAAADN0Uk5TAFX/7aQ6StSIn5njqzm8cc2r3+7wAnUTuSX8NkBHWVlzamZ7gL/boPMtO8zliqHiRt/PB4XfXAAAALlJREFUeJyt0tkOgjAQheFpFRV33BcUUVxw1/d/OEnbqTZ22sR4rgj/dzEXBfjTGH+vVA4AxBfTvcKNVRWoaRCagCtQ16BhB03sLW4HbQQdAnQRRAToIegTYECdgIAPJRiRYCzBhARTCWYkmIsef3UNFgIsaZAIsKJBKsCaBht5ZLZV+wCh+BGbrybFzsC+yNNh5+nqsD3ZJTjkHpDRXT6LowOcin52dLgU4OoC+c19AsD98Qyc4Ke9AKjDCtFEAdarAAAAAElFTkSuQmCC"

/***/ }),

/***/ "idKl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


var copy = function copy(text, success, err) {
    if (!text) {
        if (err) {
            err("数据为空");
        }
        return;
    }

    var input;
    input = document.getElementById("plugIn-input");

    if (!input) {
        // 创建一个input节点
        var input = document.createElement("input");
    }

    input.value = text;
    input.setAttribute('type', 'text');
    input.id = "plugIn-input";
    input.style.opacity = "0";
    input.style.position = "absolute";
    input.style.top = "0";
    input.style.left = "-1000px";

    // 获取body
    document.body.appendChild(input);

    input.focus();
    input.select();

    try {
        if (document.execCommand('copy', false, null)) {
            if (success) {
                success();
            }
        } else {
            if (err) {
                err();
            }
        }
    } catch (e) {
        if (err) {
            err(e);
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (copy);

/***/ }),

/***/ "jfM7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"dragBox",staticClass:"drag-box"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "k5WP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            show: false,
            e: {},
            list: {}
        };
    },


    computed: {},
    watch: {},
    methods: {
        init: function init() {},
        click: function click(item, index) {
            if (this.list.click) {
                this.list.click(item, index);
            }
            this.close();
        },
        close: function close() {
            this.show = false;
        },
        keydown: function keydown(e) {
            if (!this.show) {
                return;
            }

            e.preventDefault();

            if (e.keyCode === 27) {
                // esc关闭消息
                if (this.show) {
                    this.close();
                }
            }
        }
    },
    mounted: function mounted() {
        var that = this;
        document.addEventListener("keydown", this.keydown);
    },
    beforeDestroy: function beforeDestroy() {
        document.removeEventListener("keydown", this.keydown);
    }
});

/***/ }),

/***/ "lRg7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var message = function message() {
    return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, "N6NK"));
};
var keyWord = function keyWord() {
    return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, "ALNx"));
};
var ip = function ip() {
    return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, "eGIr"));
};

/* harmony default export */ __webpack_exports__["a"] = ([{
    path: "/system/message",
    name: "message",
    components: {
        default: message
    },
    meta: {
        nav: "system",
        navChild: "message",
        navName: "消息管理",
        keepAlive: true
    }
}, {
    path: "/system/keyWord",
    name: "keyWord",
    components: {
        default: keyWord
    },
    meta: {
        nav: "system",
        navChild: "keyWord",
        navName: "过滤词管理",
        keepAlive: true
    }
}, {
    path: "/system/ip",
    name: "ip",
    components: {
        default: ip
    },
    meta: {
        nav: "system",
        navChild: "ip",
        navName: "过滤IP管理",
        keepAlive: true
    }
}]);

/***/ }),

/***/ "lSJc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {};
    },

    methods: {},
    mounted: function mounted() {}
});

/***/ }),

/***/ "lYlZ":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "m+mu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nKCs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var service = function service() {
    return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "wBz0"));
};
var knowledge = function knowledge() {
    return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, "dL9B"));
};
var commonProblem = function commonProblem() {
    return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, "UPg3"));
};
var overChat = function overChat() {
    return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "+Wgb"));
};

/* harmony default export */ __webpack_exports__["a"] = ([
// 客服
{
    path: "/",
    name: "service",
    components: {
        default: service
    },
    meta: {
        nav: "service",
        navChild: "",
        navName: "接待中",
        keepAlive: true
    }
}, {
    path: "/service/overChat",
    name: "overChat",
    components: {
        default: overChat
    },
    meta: {
        nav: "service",
        navChild: "overChat",
        navName: "已接待",
        keepAlive: true
    }
}, {
    path: "/service/knowledge",
    name: "knowledge",
    components: {
        default: knowledge
    },
    meta: {
        nav: "service",
        navChild: "knowledge",
        navName: "知识库",
        keepAlive: true
    }
}, {
    path: "/service/commonProblem",
    name: "commonProblem",
    components: {
        default: commonProblem
    },
    meta: {
        nav: "service",
        navChild: "commonProblem",
        navName: "常见问题",
        keepAlive: true
    }
}]);

/***/ }),

/***/ "nNGG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav2_vue__ = __webpack_require__("IlgU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a87e73b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav2_vue__ = __webpack_require__("+Knr");
function injectStyle (ssrContext) {
  __webpack_require__("qduw")
  __webpack_require__("asmb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1a87e73b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a87e73b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "naDd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
    sessionId: "",
    appId: "000000",
    user: {
        sessionId: "",
        receiveWebsocketNotify: false
    },

    hiddenNav: false,

    historyList: [],
    //范围时间选择器
    pickerOptions: {
        shortcuts: [{
            text: "今天",
            onClick: function onClick(picker) {
                var start = new Date(new Date(new Date().toLocaleDateString()).getTime());
                var end = new Date(new Date(new Date().toLocaleDateString()).getTime() + (24 * 60 * 60 * 1000 - 1));

                picker.$emit("pick", [start, end]);
            }
        }, {
            text: "昨天",
            onClick: function onClick(picker) {
                var start = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000);
                var end = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 + (24 * 60 * 60 * 1000 - 1));

                picker.$emit("pick", [start, end]);
            }
        }, {
            text: "过去7天",
            onClick: function onClick(picker) {
                var start = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 * 7);
                var end = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 + (24 * 60 * 60 * 1000 - 1));
                picker.$emit("pick", [start, end]);
            }
        }, {
            text: "过去30天",
            onClick: function onClick(picker) {
                var start = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 * 30);
                var end = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 + (24 * 60 * 60 * 1000 - 1));
                picker.$emit("pick", [start, end]);
            }
        }]
    },

    // 如果父导航有child  则会忽略父导航上的router
    navigationList: [{
        icon: 'el-icon-service',
        text: '客服中心',
        nav: 'service',
        role: ['admin', 'manager', 'service'],
        open: true,
        child: [{
            text: "接待中",
            nav: "",
            router: "/",
            role: []
        }, {
            text: "已接待",
            nav: "overChat",
            router: "/service/overChat",
            role: []
        }, {
            text: "知识库",
            nav: "knowledge",
            router: "/service/knowledge",
            role: ['admin', 'manager']
        }, {
            text: "常见问题",
            nav: "commonProblem",
            router: "/service/commonProblem",
            role: ['admin', 'manager']
        }]
    }, {
        icon: 'el-icon-service',
        text: '工单管理',
        nav: 'workOrder',
        role: [],
        open: true,
        child: [{
            text: "全部工单",
            nav: "allWorkOrder",
            router: "/workOrder/allWorkOrder",
            role: ['admin', 'manager', 'ticket_manager']
        }, {
            text: "我的工单",
            nav: "myWorkOrder",
            router: "/workOrder/myWorkOrder",
            role: []
        }]
    }, {
        icon: 'el-icon-service',
        text: '私聊',
        nav: 'chat',
        role: ['admin', 'manager'],
        open: true,
        child: [{
            text: "聊天记录",
            nav: "chat",
            router: "/chat",
            role: []
        }, {
            text: "对话统计",
            nav: "statistics",
            router: "/chat/statistics",
            role: []
        }]
    }, {
        icon: 'el-icon-info',
        text: '会话标签',
        nav: 'historyTag',
        router: "/historyTag",
        role: ['admin', 'manager', 'service']
    }, {
        icon: 'el-icon-setting',
        text: '设置',
        nav: 'setting',
        role: ['admin'],
        child: [{
            text: "用户管理",
            nav: "staff",
            router: "/setting/staff",
            role: []
        }, {
            text: "客服组管理",
            nav: "groups",
            router: "/setting/groups",
            role: []
        }, {
            text: "工单组管理",
            nav: "taskGroup",
            router: "/setting/taskGroup",
            role: []
        }, {
            text: "应用管理",
            nav: "app",
            router: "/setting/app",
            role: []
        }, {
            text: "基础配置",
            nav: "onOff",
            router: "/setting/onOff",
            role: []
        }, {
            text: "时间计划",
            nav: "time",
            router: "/setting/time",
            role: []
        }, {
            text: "标签管理",
            nav: "messageTag",
            router: "/setting/messageTag",
            role: []
        }, {
            text: "咨询分类管理",
            nav: "consultClassify",
            router: "/setting/consultClassify",
            role: []
        }]
    }, {
        icon: 'el-icon-date',
        text: '管理',
        nav: 'system',
        role: ['admin'],
        child: [{
            text: "消息管理",
            nav: "message",
            router: "/system/message",
            role: []
        }, {
            text: "过滤词管理",
            nav: "keyWord",
            router: "/system/keyWord",
            role: []
        }, {
            text: "过滤IP管理",
            nav: "ip",
            router: "/system/ip",
            role: []
        }]
    }, {
        icon: 'el-icon-date',
        text: '工作报表',
        nav: 'workReport',
        role: ['admin', 'manager'],
        child: [{
            text: "工作量统计",
            nav: "workload",
            router: "/workReport/workload",
            role: []
        }, {
            text: "咨询分类统计",
            nav: "consultClassifyReport",
            router: "/workReport/consultClassifyReport",
            role: []
        }, {
            text: "分时统计",
            nav: "trendCount",
            router: "/workReport/trendCount",
            role: []
        }, {
            text: "工作质量概览",
            nav: "workQuality",
            router: "/workReport/workQuality",
            role: []
        }, {
            text: "工作质量详情",
            nav: "workQualityDetail",
            router: "/workReport/workQualityDetail",
            role: []
        }]
    }]
};

/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),

/***/ "on3G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jsonType_index__ = __webpack_require__("ZLYb");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: "wxChat",

    components: {
        'v-json-type': __WEBPACK_IMPORTED_MODULE_0__jsonType_index__["a" /* default */]
    },

    props: {
        data: {
            type: Array,
            required: true
        },
        hiddenTime: {
            type: Boolean,
            required: false
        },
        showPopover: {
            type: Boolean,
            required: false
        },
        openCreat: {
            type: Function,
            required: false
        }
    },

    data: function data() {
        return {
            isUpperLaoding: false,
            isUnderLaoding: false,

            isRefreshedAll: false,
            isLoadedAll: false,

            minHeight: 700,
            dataArray: [],

            ops2: {
                vuescroll: {
                    mode: "native"
                },
                sizeStrategy: "number",
                scrollPanel: {
                    // 是否禁止x或y方向上的滚动
                    scrollingX: false,
                    scrollingY: true
                },
                scrollContent: {},
                vRail: {}
            },

            // 跨组转接备注
            showRoleListDescription: false,
            transferOutDescription: "",
            // 客户评价开关
            evaluationShow: false,
            descriptionInfo: {
                star: 4
            }
        };
    },
    created: function created() {
        this.initData();
    },
    mounted: function mounted() {
        //document.getElementsByTagName('body')[0].scrollTop=0;
        this.minHeight = document.getElementById("window-view-container").offsetHeight;
        // this.maxHeight = document.getElementById('window-view-container').offsetHeight;
    },


    methods: {
        copy: function copy(text) {
            var that = this;
            that.$copy(text, function () {
                that.$message({
                    message: "复制成功",
                    type: "success"
                });
            });
        },
        isToday: function isToday(time) {
            var d = new Date(time).toDateString() === new Date().toDateString();
            if (d) {
                return true;
            } else {
                return false;
            }
        },
        showTreeList: function showTreeList(e) {
            var parent = e.currentTarget.parentNode.parentNode;
            var dom = parent.getElementsByClassName("listCon")[0];

            if (dom.style.display == "none" || !dom.style.display) {
                dom.style.display = "block";
            } else {
                dom.style.display = "none";
            }
        },
        openMenuTag: function openMenuTag(e, data) {
            var that = this;
            var biaoqian = this.$route.name == "service" ? "打标签" : "";

            this.$openMenu(e, {
                array: [{
                    text: biaoqian
                }, {
                    text: that.$route.name == 'service' || that.$route.name == 'overChat' || that.$route.name == 'chat' || that.$route.name == 'workQualityDetail' || that.$route.name == 'message' ? "\u521B\u5EFA\u5DE5\u5355" : ""
                }],
                click: function click(item, index) {
                    if (index == 0) {
                        that.$emit("openMessageTag", data);
                    } else if (index == 1) {
                        // console.log(data,'menuTag创建工单')
                        that.$emit('openCreat', 'resource', data);
                    }
                }
            });
        },
        openMenu: function openMenu(e, data) {
            var that = this;

            var seleText = window.getSelection().toString();
            var color = window.getSelection().toString() ? "" : "#888";

            var biaoqian = this.$route.name == "service" || this.$route.name == "window" ? "打标签" : "";

            this.$openMenu(e, {
                array: [{
                    text: "\u590D\u5236\u9009\u4E2D\u6587\u5B57(" + seleText + ")",
                    color: color
                }, {
                    text: "\u590D\u5236\u6574\u6761\u4FE1\u606F"
                }, {
                    text: biaoqian
                }, {
                    text: that.$route.name == 'service' || that.$route.name == 'overChat' || that.$route.name == 'chat' || that.$route.name == 'workQualityDetail' || that.$route.name == 'message' ? "\u521B\u5EFA\u5DE5\u5355" : ""
                }],
                click: function click(item, index) {
                    if (index == 0) {
                        // 复制选中
                        that.$copy(seleText, function () {
                            that.$message({
                                message: "复制成功",
                                type: "success"
                            });
                        });
                    } else if (index == 1) {
                        //   复制整条
                        that.$copy(data.content, function () {
                            that.$message({
                                message: "复制成功",
                                type: "success"
                            });
                        });
                    } else if (index == 2) {
                        that.$emit("openMessageTag", data);
                    } else if (index == 3) {
                        // console.log(that.$route,'menu创建工单')
                        that.$emit('openCreat', 'resource', data);
                    }
                }
            });
        },
        openMenuImg: function openMenuImg(e, data, imgIndex) {
            var that = this;

            // let seleText = window.getSelection().toString()
            // let color =  window.getSelection().toString()?'':'#888'

            var biaoqian = this.$route.name == "service" ? "打标签" : "";

            this.$openMenu(e, {
                array: [{
                    text: "\u653E\u5927"
                }, {
                    text: "\u65B0\u9875\u9762\u6253\u5F00\u56FE\u7247"
                }, {
                    text: biaoqian
                }, {
                    text: that.$route.name == 'service' || that.$route.name == 'overChat' || that.$route.name == 'chat' || that.$route.name == 'workQualityDetail' || that.$route.name == 'message' ? "\u521B\u5EFA\u5DE5\u5355" : ""
                }],
                click: function click(item, index) {
                    if (index == 0) {
                        // 放大
                        that.clickImg(imgIndex);
                    } else if (index == 1) {
                        // console.log(window.open)
                        window.open(data.imgUrl);
                    } else if (index == 2) {
                        that.$emit("openMessageTag", data);
                    } else if (index == 3) {
                        // console.log(data,'menuImg创建工单')
                        that.$emit('openCreat', 'resource', data);
                    }
                }
            });
        },
        isShowTime: function isShowTime(index) {
            // 判断是否显示time
            if (!this.hiddenTime) {
                return true;
            }
            // 第一条必定显示
            if (index == 0) {
                return true;
            } else {
                // 第二条判断3分钟
                var time = this.data[index].sendTime - this.data[index - 1].sendTime;
                // 三分钟
                var dTime = 1000 * 60 * 3;

                if (time >= dTime) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        clickImg: function clickImg(e) {
            var arr = [];
            var j = 0;
            if (this.data) {
                for (var i = 0; i < this.data.length; i++) {
                    if (this.data[i].msgType == "image") {
                        arr.push(this.data[i].imgUrl);
                        if (i <= e) {
                            j++;
                        }
                    }
                }
            }
            var obj = {
                list: arr,
                index: j - 1
            };
            this.$previewImg(obj);
        },
        link: function link(url) {
            if (url) {
                window.location.href = url;
            }
        },
        linkCard: function linkCard(url) {
            if (url) {
                if (url.substr(0, 4) == "http") {
                    window.open(url);
                }
            }
        },

        // clickTransferOut(item){
        //     if(item.description){
        //         this.$emit("clickTransferOut",item);
        //     }
        // },
        // 跨组转接备注
        clickTransferOut: function clickTransferOut(item) {
            var _this = this;

            var id = item.description;
            if (!id) {
                return;
            }
            this.$reqPost("/api/transfer/" + id + "/get", {}).then(function (res) {
                if (res.data.returnData.description) {
                    _this.transferOutDescription = res.data.returnData.description;
                    _this.showRoleListDescription = true;
                } else {
                    _this.$message.error("无备注信息");
                }
            }, function (err) {});
        },
        closeRoleListDescription: function closeRoleListDescription() {
            this.showRoleListDescription = false;
            this.transferOutDescription = "";
        },
        clickRTF: function clickRTF(e) {
            if (e.target.tagName == "IMG" && e.target.getAttribute("src")) {
                var arr = [];
                arr.push(e.target.getAttribute("src"));
                var obj = {
                    list: arr,
                    index: 0
                };
                this.$previewImg(obj);
            }
        },
        imgLoad: function imgLoad() {
            this.$emit("imgLoad");
        },
        initData: function initData() {
            this.dataArray = this.dataArray.concat(this.data);
        },
        openEvaluationDialog: function openEvaluationDialog(description) {
            console.log('打开评价界面');
            this.evaluationShow = true;
            this.descriptionInfo = JSON.parse(description);
        }
    }
});

/***/ }),

/***/ "oxY6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pVSU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "dragImgUpload",
    data: function data() {
        return {
            file: null,
            errText: ""
        };
    },

    computed: {},
    mounted: function mounted() {
        var _this2 = this;

        // 阻止浏览器默认的拖拽时事件
        ["dragleave", "drop", "dragenter", "dragover"].forEach(function (e) {
            _this2.preventDefaultEvent(e);
        });

        // 绑定拖拽支持
        this.addDropSupport();
        // 绑定粘贴支持
        this.addPasteSupport();
    },

    methods: {
        preventDefaultEvent: function preventDefaultEvent(eventName) {
            document.addEventListener(eventName, function (e) {
                e.preventDefault();
            }, false);
        },

        // 粘贴
        addPasteSupport: function addPasteSupport() {
            var _this = this;
            var drag = this.$refs.dragBox;
            var file = null;
            drag.addEventListener("paste", function (e) {
                //not for ie11  某些chrome版本使用的是event.originalEvent
                if (e.clipboardData || e.originalEvent) {
                    var clipboardData = event.clipboardData || event.originalEvent.clipboardData;
                    var items = clipboardData.items;
                    if (items[0].type.indexOf("image") !== -1) {
                        //getAsFile() 此方法只是living standard firefox ie11 并不支持
                        file = items[0].getAsFile(); // 只需要最后一张

                        e.preventDefault();

                        _this.handleFileChange({
                            files: [file]
                        });
                    }
                }
            });
        },

        // 拖拽
        addDropSupport: function addDropSupport() {
            var _this = this;
            var drag = this.$refs.dragBox;

            drag.addEventListener("drop", function (e) {
                e.preventDefault();
                // dataTransfer承载拖拽数据
                var fileList = e.dataTransfer.files;

                if (fileList.length === 0) {
                    return false;
                }

                _this.handleFileChange({
                    files: fileList
                });
            });
        },

        // Change
        handleFileChange: function handleFileChange(e) {
            this.$emit("onChange", e);
        }
    }
});

/***/ }),

/***/ "qduw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r7cV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wxchat-container",on:{"contextmenu":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"window",attrs:{"id":"window-view-container"}},[_c('div',{staticClass:"message"},[(_vm.data)?_c('ul',{staticStyle:{"padding":"0"}},_vm._l((_vm.data),function(message,index){return _c('li',{key:index + '' + message.type,class:message.type=='receive'?'an-move-right':'an-move-left'},[(message.msgType == 'event')?_c('div',{staticClass:"event"},[(message.type == 'client_appraisal' && _vm.$router.history.current.fullPath=='/workReport/workQualityDetail')?_c('div',{staticClass:"evaluation_mes",on:{"click":function($event){$event.stopPropagation();_vm.openEvaluationDialog(message.description)}}},[(_vm.isToday(message.sendTime))?_c('span',[_c('span',[_vm._v(_vm._s(_vm._f("formatterDate")(parseInt(message.sendTime),"今天 HH:mm:ss")))])]):_c('span',[_c('span',[_vm._v(_vm._s(_vm._f("formatterDate")(parseInt(message.sendTime),"yyyy-MM-dd HH:mm:ss")))])]),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"10px"}},[_vm._v("客户提交满意度评价")])]):_c('div',{staticClass:"eventText"},[(_vm.isToday(message.sendTime))?_c('span',[_c('span',[_vm._v(_vm._s(_vm._f("formatterDate")(parseInt(message.sendTime),"今天 HH:mm:ss")))])]):_c('span',[_c('span',[_vm._v(_vm._s(_vm._f("formatterDate")(parseInt(message.sendTime),"yyyy-MM-dd HH:mm:ss")))])]),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"10px"}},[_vm._v(_vm._s(message.content))])])]):(message.msgType == 'transfer_out')?_c('div',{staticClass:"transfer-out"},[_c('div',{staticClass:"transfer-out-con",on:{"click":function($event){_vm.clickTransferOut(message)}}},[_c('span',{staticClass:"transfer-out-text"},[_vm._v(_vm._s(message.content))]),_vm._v(" "),(message.description)?_c('img',{staticClass:"icon",attrs:{"src":__webpack_require__("S5Ji"),"alt":""}}):_vm._e()])]):(message.msgType == 'transfer_in')?_c('div',{staticClass:"transfer-out"},[_c('div',{staticClass:"transfer-out-con",on:{"click":function($event){_vm.clickTransferOut(message)}}},[_c('span',{staticClass:"transfer-out-text"},[_vm._v(_vm._s(message.content))]),_vm._v(" "),(message.description)?_c('img',{staticClass:"icon",attrs:{"src":__webpack_require__("S5Ji"),"alt":""}}):_vm._e()])]):_c('div',[(_vm.isShowTime(index))?_c('div',[(_vm.isToday(message.sendTime))?_c('p',{staticClass:"time"},[_c('span',[_vm._v(_vm._s(_vm._f("formatterDate")(parseInt(message.sendTime),"今天 HH:mm:ss")))])]):_c('p',{staticClass:"time"},[_c('span',[_vm._v(_vm._s(_vm._f("formatterDate")(parseInt(message.sendTime),"yyyy-MM-dd HH:mm:ss")))])])]):_vm._e(),_vm._v(" "),(message.msgType == 'cardExt')?_c('v-json-type',{attrs:{"json":message.extData}}):_c('div',{class:'main' + (message.type=='receive'?' self':'')},[_c('div',{staticClass:"sendUser"},[(!_vm.showPopover)?_c('div',[(message.sendUserAvatar)?_c('img',{staticClass:"avatar",attrs:{"src":message.sendUserAvatar,"alt":""}}):_c('img',{staticClass:"avatar",attrs:{"src":__webpack_require__("0gU3"),"alt":""}})]):_c('div',[_c('el-popover',{attrs:{"transition":"none","offset":500,"placement":"right-end","trigger":"click"}},[_c('div',{staticClass:"img",attrs:{"slot":"reference"},slot:"reference"},[(message.sendUserAvatar)?_c('img',{staticClass:"avatar",staticStyle:{"cursor":"pointer"},attrs:{"src":message.sendUserAvatar,"alt":""}}):_c('img',{staticClass:"avatar",staticStyle:{"cursor":"pointer"},attrs:{"src":__webpack_require__("0gU3"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"itemDialog"},[_c('div',{staticClass:"dialog-top"},[(message.sendUserAvatar)?_c('img',{staticClass:"img",attrs:{"width":"35","height":"35","alt":"","src":message.sendUserAvatar}}):_c('img',{staticClass:"img",attrs:{"width":"35","height":"35","alt":"","src":__webpack_require__("0gU3")}}),_vm._v(" "),_c('div',{staticClass:"text"},[(message.sendUserName)?_c('span',[_vm._v(_vm._s(message.sendUserName))]):_c('span',[_vm._v("匿名用户")])])]),_vm._v(" "),_c('div',{staticClass:"dialog-bottom"},[_c('span',[_vm._v("访客标识：")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(message.sendUserId))])]),_vm._v(" "),(message.device)?_c('div',{staticClass:"dialog-bottom"},[_c('span',[_vm._v("设备信息：")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(message.device))])]):_vm._e(),_vm._v(" "),(message.extraData)?_c('div',{staticClass:"dialog-bottom"},[_c('span',[_vm._v("其他信息：")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(message.extraData))])]):_vm._e()])])],1),_vm._v(" "),_c('span',{staticClass:"sendUserName"},[_vm._v(_vm._s(message.sendUserName))])]),_vm._v(" "),(message.msgType=='text')?_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.$options.filters.emoji(message.content))},on:{"contextmenu":function($event){$event.preventDefault();$event.stopPropagation();_vm.openMenu($event,message)}}}):(message.msgType=='image')?_c('div',{staticClass:"text text-image"},[_c('img',{staticClass:"image",attrs:{"src":message.imgUrl,"alt":"聊天图片"},on:{"contextmenu":function($event){$event.preventDefault();$event.stopPropagation();_vm.openMenuImg($event,message,index)},"click":function($event){_vm.clickImg(index)},"load":function($event){_vm.imgLoad()}}})]):(message.msgType=='laodingimage')?_c('div',{staticClass:"text text-image"},[_c('div',{staticClass:"laodingimage"},[_c('span',{staticClass:"laodingimagetext"},[_vm._v("图片发送中...")])]),_vm._v(" "),_c('img',{staticClass:"image",attrs:{"imgId":message.imgId,"src":message.imgUrl,"alt":"[图片加载失败]"},on:{"load":function($event){_vm.imgLoad()}}})]):(message.msgType=='card')?_c('div',{staticClass:"text goods",staticStyle:{"background":"#fff","border":"1px solid #eee"},on:{"contextmenu":function($event){$event.preventDefault();$event.stopPropagation();_vm.openMenuTag($event,message)},"click":function($event){_vm.linkCard(message.forwardUrl)}}},[_c('div',[_vm._v(_vm._s(message.description))]),_vm._v(" "),_c('div',{staticStyle:{"overflow":"hidden","margin-bottom":"5px"}},[_c('div',{staticClass:"left",staticStyle:{"font-size":"12px","color":"#999"}},[_vm._v(_vm._s(message.content))]),_vm._v(" "),_c('img',{staticClass:"right",attrs:{"src":message.imgUrl,"alt":""}})])]):(message.msgType=='tree')?_c('div',{staticClass:"text tree",on:{"contextmenu":function($event){$event.preventDefault();$event.stopPropagation();_vm.openMenuTag($event,message)}}},[_c('div',{staticClass:"treeTitle"},[_c('div',{staticClass:"left"},[_vm._v("常见问题")]),_vm._v(" "),_c('div',{staticClass:"right",on:{"click":_vm.showTreeList}},[_c('i',{staticClass:"el-icon-arrow-down",staticStyle:{"position":"relative"}}),_vm._v(" "),_c('span',[_vm._v("展开")])])]),_vm._v(" "),_c('div',{staticClass:"listCon"},_vm._l((message.content),function(item,index){return _c('div',{key:'tree' + index,staticClass:"item"},[_c('div',{staticClass:"itemText"},[_vm._v(_vm._s(item.title))])])}))]):(message.msgType == 'contact')?_c('div',{staticClass:"contact"},[_c('div',{staticClass:"text"},[_c('div',{staticClass:"contact-content"},[_vm._v("\n                                        "+_vm._s(message.content)+"\n                                    ")]),_vm._v(" "),(message.mobile)?_c('div',{staticClass:"contact-item",on:{"click":function($event){_vm.copy(message.mobile)}}},[_c('span',[_vm._v("电话：")]),_vm._v(" "),_c('span',{staticClass:"contact-item-btn"},[_vm._v(_vm._s(message.mobile))])]):_vm._e(),_vm._v(" "),(message.wxAccount)?_c('div',{staticClass:"contact-item",on:{"click":function($event){_vm.copy(message.wxAccount)}}},[_c('span',[_vm._v("微信：")]),_vm._v(" "),_c('span',{staticClass:"contact-item-btn"},[_vm._v(_vm._s(message.wxAccount))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"contact-remark"},[_vm._v("\n                                        点击手机号、微信号可复制\n                                    ")])])]):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"tag"},_vm._l((message.tags),function(tag){return _c('div',{key:tag.id,staticClass:"tagText"},[(_vm.isToday(tag.crtTime))?_c('span',[_c('span',[_vm._v(_vm._s(_vm._f("formatterDate")(parseInt(tag.crtTime),"今天 HH:mm:ss")))])]):_c('span',[_c('span',[_vm._v(_vm._s(_vm._f("formatterDate")(parseInt(tag.crtTime),"yyyy-MM-dd HH:mm:ss")))])]),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"10px"}},[_vm._v(_vm._s(tag.tagName))])])}))])})):_vm._e()])]),_vm._v(" "),_c('el-dialog',{staticClass:"roleListDescription-dialog",attrs:{"append-to-body":true,"title":"跨组转接备注","visible":_vm.showRoleListDescription,"before-close":_vm.closeRoleListDescription,"close-on-click-modal":false},on:{"update:visible":function($event){_vm.showRoleListDescription=$event}}},[_c('vue-scroll',{attrs:{"ops":_vm.ops2}},[_c('div',{staticClass:"ql-editor",domProps:{"innerHTML":_vm._s(_vm.transferOutDescription)},on:{"click":_vm.clickRTF}})])],1),_vm._v(" "),_c('el-dialog',{staticClass:"evaluation_dialog",attrs:{"width":"400px","modal":false,"visible":_vm.evaluationShow},on:{"update:visible":function($event){_vm.evaluationShow=$event}}},[_c('div',{staticClass:"evalution_title"},[_vm._v("客户满意度评价")]),_vm._v(" "),_c('div',{staticClass:"solve_box"},[(_vm.descriptionInfo.solved)?_c('div',{staticClass:"btn btn_on",staticStyle:{"background":"#0098FF","color":"#fff"}},[_c('img',{staticClass:"solve_img",attrs:{"src":__webpack_require__("AaPB")}}),_vm._v("\n                    已解决\n                ")]):_c('div',{staticClass:"btn btn_off",staticStyle:{"color":"#C1C1C1"}},[_c('img',{staticClass:"solve_img",attrs:{"src":__webpack_require__("iNnk")}}),_vm._v("\n                    未解决\n                ")])]),_vm._v(" "),_c('div',{staticClass:"rate_box"},[_c('div',{staticClass:"star_box"},[_vm._l((_vm.descriptionInfo.star),function(item,index){return _c('img',{key:index+'like',staticClass:"star",attrs:{"src":__webpack_require__("Qn33")}})}),_vm._v(" "),_vm._l((4-_vm.descriptionInfo.star),function(index){return _c('img',{key:index+'unlike',staticClass:"star",attrs:{"src":__webpack_require__("lYlZ")}})})],2),_vm._v(" "),(_vm.descriptionInfo.star == 4)?_c('span',{staticStyle:{"color":"#faba4a"}},[_vm._v("非常满意")]):(_vm.descriptionInfo.star == 3)?_c('span',{staticStyle:{"color":"#faba4a"}},[_vm._v("满意")]):(_vm.descriptionInfo.star == 2)?_c('span',{staticStyle:{"color":"#505050"}},[_vm._v("一般")]):(_vm.descriptionInfo.star == 1)?_c('span',{staticStyle:{"color":"#505050"}},[_vm._v("不满意")]):_vm._e()]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.descriptionInfo.msg),expression:"descriptionInfo.msg"}],staticClass:"suggest",attrs:{"disabled":"","cols":"30","rows":"10"},domProps:{"value":(_vm.descriptionInfo.msg)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.descriptionInfo, "msg", $event.target.value)}}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rH90":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var login = function login() {
    return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, "T+/8"));
};
var test = function test() {
    return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, "7Zj+"));
};

/* harmony default export */ __webpack_exports__["a"] = ([{
    path: "/login",
    name: "login",
    components: {
        default: login
    },
    meta: {
        nav: "login",
        keepAlive: false,
        hiddenNavigation: true
    }
}, {
    path: "/test",
    name: "test",
    components: {
        default: test
    },
    meta: {
        nav: "test",
        keepAlive: true,
        hiddenNavigation: true
    }
}]);

/***/ }),

/***/ "rKOJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__treeSelectChild_vue__ = __webpack_require__("8byh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            showChild: false
        };
    },

    props: {
        placeholder: {
            type: String,
            default: false
        },
        value: {
            type: String,
            default: false
        }
    },
    components: {
        "v-tree-select-child": __WEBPACK_IMPORTED_MODULE_1__treeSelectChild_vue__["a" /* default */]
    },
    methods: {
        focus: function focus() {
            var _this = this;

            this.showChild = true;
            this.$nextTick(function () {
                _this.$emit('show');
            });
        },
        close: function close() {
            this.showChild = false;
        },
        open: function open() {}
    },
    mounted: function mounted() {}
});

/***/ }),

/***/ "syfT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            show: false,
            imgList: [],
            index: 0
        };
    },


    computed: {},
    watch: {},
    methods: {
        close: function close() {
            this.show = false;
        },
        up: function up() {
            if (!this.show) {
                return;
            }

            // 变大
            var dom = this.$refs.img[0];
            var h = dom.offsetHeight;
            var w = dom.offsetWidth;

            // 过小图片放大  特殊处理
            if (w < 42 || h < 42) {
                var b = void 0;

                b = 42 / w > 42 / h ? 42 / w : 42 / h;

                b++;

                dom.style.width = b * w + "px";
                dom.style.height = b * h + "px";

                dom.classList.add("change");
                return;
            }

            dom.style.width = 1.025 * w + "px";
            dom.style.height = 1.025 * h + "px";

            dom.classList.add("change");
        },
        down: function down() {
            if (!this.show) {
                return;
            }

            // 变小
            var dom = this.$refs.img[0];
            var h = dom.offsetHeight;
            var w = dom.offsetWidth;

            if (w < 45 || h < 45) {
                return;
            }

            dom.style.width = 0.975 * w + "px";
            dom.style.height = 0.975 * h + "px";

            dom.classList.add("change");
        },

        // 前一张
        prev: function prev() {
            if (!this.show) {
                return;
            }

            if (this.index == 0) {
                this.index = this.imgList.length - 1;
            } else {
                this.index--;
            }
        },

        // 后一张
        next: function next() {
            if (!this.show) {
                return;
            }

            if (this.index == this.imgList.length - 1) {
                this.index = 0;
            } else {
                this.index++;
            }
        },
        mousedown: function mousedown(e) {
            // 背景
            var back = e.currentTarget;
            // 监听mousemove

            // 监听拖动
            document.addEventListener("mousemove", this.mousemove);

            //
            document.addEventListener("mouseup", this.mouseup);
        },
        mouseup: function mouseup(e) {
            document.removeEventListener("mousemove", this.mousemove);
            document.removeEventListener("mouseup", this.mouseup);
        },
        mousemove: function mousemove(e) {
            var x = e.movementX;
            var y = e.movementY;

            var dom = this.$refs.img[0];

            var t = dom.style.transform;

            var tx = t.match(/translateX\((.*?)px\)/)[1];
            var ty = t.match(/translateY\((.*?)px\)/)[1];

            tx = parseInt(tx);
            ty = parseInt(ty);

            dom.style.transform = "translateX(" + (x + tx) + "px) translateY(" + (y + ty) + "px)";
        },
        keydown: function keydown(e) {
            if (!this.show) {
                return;
            }

            e.preventDefault();

            if (e.keyCode === 37 || e.keyCode === 38) {
                //左键 上
                this.prev();
            }
            if (e.keyCode === 39 || e.keyCode === 40) {
                //右键 下
                this.next();
            }
            if (e.keyCode === 27) {
                // esc关闭消息
                if (this.show) {
                    this.close();
                }
            }
        }
    },
    mounted: function mounted() {
        var that = this;
        document.addEventListener("keydown", this.keydown);

        //兼容性写法，该函数也是网上别人写的，不过找不到出处了，蛮好的，所有我也没有必要修改了
        //判断鼠标滚轮滚动方向
        if (window.addEventListener)
            //FF,火狐浏览器会识别该方法
            window.addEventListener("DOMMouseScroll", wheel, false);
        window.onmousewheel = document.onmousewheel = wheel; //W3C
        //统一处理滚轮滚动事件
        function wheel(event) {
            if (!that.show) {
                return;
            }

            event.preventDefault();

            var delta = 0;
            if (!event) event = window.event;
            if (event.wheelDelta) {
                //IE、chrome浏览器使用的是wheelDelta，并且值为“正负120”
                delta = event.wheelDelta / 120;
                if (window.opera) delta = -delta; //因为IE、chrome等向下滚动是负值，FF是正值，为了处理一致性，在此取反处理
            } else if (event.detail) {
                //FF浏览器使用的是detail,其值为“正负3”
                delta = -event.detail / 3;
            }
            if (delta) handle(delta);
        }
        //上下滚动时的具体处理函数
        function handle(delta) {
            if (delta < 0) {
                //向下滚动
                that.down();
            } else {
                //向上滚动
                that.up();
            }
        }
    },
    beforeDestroy: function beforeDestroy() {
        document.removeEventListener("keydown", this.keydown);
    }
});

/***/ }),

/***/ "tvR6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u3hq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("lSJc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33168cf4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("SOiF");
function injectStyle (ssrContext) {
  __webpack_require__("fNIT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-33168cf4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33168cf4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vgQg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return url; });
var Formal = {
	baseUrl: "https://51zl.zcunsoft.com"
};
var Test = {
	// baseUrl: "https://51zl.test.zcunsoft.com",
	baseUrl: "http://localhost:8089"
	// const kfalltobid = {
	//   baseUrl: "https://51zhulitest.alltobid.com",
	// }
};var url = function url() {
	// return kfalltobid
	if (window.location.host.indexOf('192.168.3.') >= 0 || window.location.host.indexOf('localhost') >= 0 || window.location.host.indexOf('51zl.test.zcunsoft.com') >= 0) {
		return Test;
	}
	if (window.location.host.indexOf('51zl.zcunsoft.com') >= 0) {
		return Formal;
	}
};


/***/ }),

/***/ "vob7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__ = __webpack_require__("syfT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_478aa554_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__ = __webpack_require__("OU2i");
function injectStyle (ssrContext) {
  __webpack_require__("KnrH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-478aa554"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_478aa554_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vyKT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            left: "",
            top: "",
            height: ""
        };
    },

    props: {
        value: {
            type: Boolean,
            default: true
        }
    },
    watch: {
        value: function value() {
            this.getParent();
        }
    },
    methods: {
        // 移动dom节点
        move: function move() {
            document.body.appendChild(this.$el);
        },

        // 获得父元素
        getParent: function getParent() {
            var dom = this.$parent.$el;

            // 获得父元素距离网页顶部的距离
            var top = dom.offsetTop;
            var left = dom.offsetLeft;

            // 获得页面高度
            var docHegiht = document.body.clientHeight;
            var height = docHegiht - top - 60;

            this.top = top;
            this.left = left;
            this.height = height;
        },
        close: function close() {
            this.$emit("close");
        }
    },
    created: function created() {},
    mounted: function mounted() {
        var _this = this;

        var vm = this;

        this.move();

        this.$nextTick(function () {
            _this.getParent();
        });
    }
});

/***/ }),

/***/ "w3wo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__previewImg___ = __webpack_require__("I3m/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__menu___ = __webpack_require__("SE3I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__copy___ = __webpack_require__("idKl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dialog___ = __webpack_require__("IQmU");





var install = function install(Vue) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};


    // 添加图片预览方法
    Vue.prototype.$previewImg = __WEBPACK_IMPORTED_MODULE_0__previewImg___["a" /* default */];

    Vue.prototype.$openMenu = __WEBPACK_IMPORTED_MODULE_1__menu___["a" /* default */];

    Vue.prototype.$copy = __WEBPACK_IMPORTED_MODULE_2__copy___["a" /* default */];

    Vue.component("p-dialog", __WEBPACK_IMPORTED_MODULE_3__dialog___["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (install);

/***/ }),

/***/ "wkuv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_treeSelect_vue__ = __webpack_require__("rKOJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f2c9144c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_treeSelect_vue__ = __webpack_require__("78mb");
function injectStyle (ssrContext) {
  __webpack_require__("WCZ/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f2c9144c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_treeSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f2c9144c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_treeSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wpK1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xC70":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dragImgUpload',
  data: function data() {
    return {
      file: null,
      errText: ''
    };
  },

  computed: {},
  mounted: function mounted() {
    var _this2 = this;

    // 阻止浏览器默认的拖拽时事件
    ['dragleave', 'drop', 'dragenter', 'dragover'].forEach(function (e) {
      _this2.preventDefaultEvent(e);
    });

    // 绑定拖拽支持
    this.addDropSupport();
    // 绑定粘贴支持
    this.addPasteSupport();
  },

  methods: {
    preventDefaultEvent: function preventDefaultEvent(eventName) {
      document.addEventListener(eventName, function (e) {
        e.preventDefault();
      }, false);
    },

    // 粘贴
    addPasteSupport: function addPasteSupport() {
      var _this = this;
      var drag = this.$refs.dragBox;
      var file = null;
      drag.addEventListener('paste', function (e) {
        //not for ie11  某些chrome版本使用的是event.originalEvent
        if (e.clipboardData || e.originalEvent) {
          var clipboardData = event.clipboardData || event.originalEvent.clipboardData;
          var items = clipboardData.items;
          if (items[0].type.indexOf("image") !== -1) {
            //getAsFile() 此方法只是living standard firefox ie11 并不支持  
            file = items[0].getAsFile(); // 只需要最后一张

            e.preventDefault();

            _this.handleFileChange({
              files: [file]
            });
          }
        }
      });
    },

    // 拖拽
    addDropSupport: function addDropSupport() {
      var _this = this;
      var drag = this.$refs.dragBox;

      drag.addEventListener('drop', function (e) {
        e.preventDefault();
        // dataTransfer承载拖拽数据
        var fileList = e.dataTransfer.files;

        if (fileList.length === 0) {
          return false;
        }

        _this.handleFileChange({
          files: fileList
        });
      });
    },

    // Change
    handleFileChange: function handleFileChange(e) {
      this.$emit('onChange', e);
    }
  }
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_js_config__ = __webpack_require__("vgQg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sockjs_client__ = __webpack_require__("O3w4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sockjs_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sockjs_client__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stompjs__ = __webpack_require__("0tEf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stompjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_stompjs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            stompClient: null,
            timeOutForReconnect: null
        };
    },

    components: {},
    created: function created() {
        var _this = this;

        if (window.location.href.search("window") != "-1") {
            return;
        }

        var sessionId = localStorage.getItem("sessionId");

        if (sessionId) {
            this.$reqPost("/api/userInfo/get", {}).then(function (res) {
                _this.$store.state.user = res.data.returnData;
                _this.$store.state.user.sessionId = sessionId;
            }, function (err) {
                _this.$router.replace("/login");
            });
        } else {
            this.$router.replace("/login");
        }
    },
    mounted: function mounted() {},

    methods: {
        initSock: function initSock() {
            var that = this;
            if (that.stompClient) {
                that.closeSock();
            }
            var socketUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__assets_js_config__["a" /* url */])().baseUrl + "/api/ws"; //连接地址
            // 建立连接对象（还未发起连接）
            var socket = new __WEBPACK_IMPORTED_MODULE_2_sockjs_client___default.a(socketUrl);
            // 获取 STOMP 子协议的客户端对象
            that.stompClient = __WEBPACK_IMPORTED_MODULE_3_stompjs___default.a.over(socket);
            //客户端发出心跳5s间隔
            that.stompClient.heartbeat.outgoing = 5000;
            //客户端接收服务端心跳5s间隔 0表示不接收
            that.stompClient.heartbeat.incoming = 5000;
            // 向服务器发起websocket连接并发送CONNECT帧
            that.stompClient.connect({ "x-auth-token": that.$store.state.user.sessionId }, //可添加客户端的认证信息
            function connectCallback(frame) {
                //连接成功的回调函数
                //订阅频道
                that.stompClient.subscribe("/user/queue/notify", function (data) {
                    if (data) {
                        var obj = JSON.parse(data.body);

                        Notification.requestPermission(function (status) {
                            var text = "";
                            if (obj.msgType == "text") {
                                text = obj.content;
                            }
                            if (obj.msgType == "image") {
                                text = "[图片消息]";
                            }
                            var n = new Notification("\u5BA2\u6237" + obj.sendUserName + "\u53D1\u9001\u4E86\u4E00\u6761\u6D88\u606F", {
                                body: text,
                                data: {
                                    url: "https://51zl.zcunsoft.com/pub/"
                                },
                                renotify: false,
                                tag: that.$guid(32),
                                //通知声源文件地址。非必须，默认为空
                                sound: "http://51zl-pro-oss.zcunsoft.com/sounds/messages.mp3",
                                icon: that.$store.state.user.appAvatar
                            }); // 显示通知

                            n.onclick = function (e) {
                                window.open(n.data.url, "_blank");
                                n.close();
                            };
                        });
                    }
                });
            }, function errorCallBack(error) {
                console.log("STOMP: " + error);
                that.timeOutForReconnect = setTimeout(function () {
                    that.initSock();
                }, 5000);
                console.log("STOMP: Reconnecting in 5 seconds");
            });
        },
        closeSock: function closeSock() {
            if (this.stompClient) {
                console.log("断开");
                clearTimeout(this.timeOutForReconnect);
                this.stompClient.disconnect(function () {});
                this.stompClient = null;
            }
        },
        active: function active() {
            if (this.$store.state.user.sessionId) {
                this.$reqPost("/api/user/status/active", {}).then(function (res) {}, function (err) {});
            }
        }
    },
    beforeMount: function beforeMount() {},

    watch: {
        "$store.state.user.sessionId": function $storeStateUserSessionId() {
            var _this2 = this;

            if (this.$store.state.user.sessionId) {
                if (this.$store.state.user.myRole == "ticket_service" || this.$store.state.user.myRole == "ticket_manager") {
                    this.$router.replace("/workOrder/myWorkOrder");
                } else {
                    this.$router.replace("/");
                }

                this.active();
                setInterval(function () {
                    _this2.active();
                }, 30000);
            }
        },
        "$store.state.user.receiveWebsocketNotify": function $storeStateUserReceiveWebsocketNotify() {
            console.log("用户设置改变");
            if (this.$store.state.user.receiveWebsocketNotify) {
                this.initSock();
            } else {
                this.closeSock();
            }
        }
    }
});

/***/ }),

/***/ "xQGL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"history-com"},[_c('div',{staticClass:"tag-con"},[(_vm.$store.state.historyList && _vm.$store.state.historyList.length)?_c('div',{staticClass:"closeAll",on:{"click":_vm.closeAll}},[_c('i',{staticClass:"el-icon-error"})]):_vm._e(),_vm._v(" "),_vm._l((_vm.$store.state.historyList),function(tag,index){return _c('div',{key:tag.meta.navName + index,on:{"click":function($event){_vm.clickTag(tag)}}},[_c('el-tag',{class:{act:tag.meta.navName == _vm.$route.meta.navName},attrs:{"closable":"","type":"info"},on:{"close":function($event){_vm.closeTag(index)}}},[_vm._v(_vm._s(tag.meta.navName))])],1)})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xUON":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z2xj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zw0+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[0]);


// WEBPACK FOOTER //
// static/js/app.7711c425784cca80bf0c.js